import React, { useEffect, useState, useCallback } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { 
  getDevisById, 
  updateDevis, 
  createPoste, 
  updatePoste, 
  deletePoste,
  clearLotPostes,
  bulkDeletePostes,
  getDevisPdf,
  getLots,
  getTitresDevis,
  createFournisseurDirect,
  updateFournisseurDirect,
  deleteFournisseurDirect,
  bulkDeleteFournisseursDirects,
  createPosteWithEnrichment,
  getBaseMaagFlat,
  updateProjet,
  resyncProjetFromBase,
  getProjet,
  getEnseignes,
  updateBaseMaagPrestation,
  addDevisLot,
  renameDevisLot,
  deleteDevisLot,
  resetDevisLots
} from '../services/api';
import axios from 'axios';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
import { 
  ArrowLeft, 
  Save,
  Download,
  Plus,
  Trash2,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  FileText,
  Calculator,
  BarChart3,
  Truck,
  Type,
  Database,
  Building2,
  Check,
  X,
  Loader2,
  Search,
  FolderInput,
  Copy,
  Lock,
  CheckCircle,
  RefreshCw,
  Sparkles,
  GripVertical,
  Edit3,
  Package,
  Globe
} from 'lucide-react';
import { toast } from 'sonner';
import AIDescriptionButton from '../components/AIDescriptionButton';
import AIRewritePosteModal from '../components/AIRewritePosteModal';
import LocalisationCombobox from '../components/LocalisationCombobox';
import { saveAs } from 'file-saver';
import PDFPreviewModal from '../components/PDFPreviewModal';
import { usePdfPreview } from '../hooks/usePdfPreview';

const DevisEditPage = () => {
  const { devisId } = useParams();
  const navigate = useNavigate();
  const { previewState: pdfPreview, openPreview: openPdfPreview, closePreview: closePdfPreview } = usePdfPreview();
  const [devis, setDevis] = useState(null);
  const [projet, setProjet] = useState(null);
  const [lots, setLots] = useState([]);
  const [titresDevis, setTitresDevis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [expandedLots, setExpandedLots] = useState({});
  const [editingPoste, setEditingPoste] = useState(null);
  const [editingPosteId, setEditingPosteId] = useState(null); // for full modal edit mode
  const [aiRewriteTarget, setAiRewriteTarget] = useState(null); // {posteId, lotNom, text}
  const [newPoste, setNewPoste] = useState({});
  const [pdfUrl, setPdfUrl] = useState('');
  const [newFD, setNewFD] = useState({ designation: '', categorie: 'intervenants', payeur: '', montant_ht: '' });
  const [resyncingFD, setResyncingFD] = useState(false);
  const [selectedFDs, setSelectedFDs] = useState(new Set());
  const [showTitreModal, setShowTitreModal] = useState(false);
  
  // Selection state for bulk operations
  const [selectedPostes, setSelectedPostes] = useState(new Set());
  const [isDeleting, setIsDeleting] = useState(false);
  
  // Sous-lot editing
  const [editingSousLot, setEditingSousLot] = useState(null); // {posteId, lotId, currentSousLot}
  const [newSousLotName, setNewSousLotName] = useState('');
  
  // New poste creation with enrichment options
  const [showNewPosteModal, setShowNewPosteModal] = useState(false);
  
  // Groupement modal state
  const [showGroupementModal, setShowGroupementModal] = useState(false);
  const [groupementLoading, setGroupementLoading] = useState(false);
  const [groupementPickerIdx, setGroupementPickerIdx] = useState(null); // index of the line whose Base MAAG picker is open
  const [groupementPickerSearch, setGroupementPickerSearch] = useState('');
  const [sousLotsTemplates, setSousLotsTemplates] = useState([]); // pre-defined sous-lots for current lot (from backend)
  
  // Groupements existants picker
  const [showGroupementsPicker, setShowGroupementsPicker] = useState(false);
  const [selectedGroupementIds, setSelectedGroupementIds] = useState(new Set());

  const toggleGroupementSelect = (id) => {
    setSelectedGroupementIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };

  const toggleSousLotSelect = (groupementsOfSousLot) => {
    setSelectedGroupementIds(prev => {
      const next = new Set(prev);
      const ids = groupementsOfSousLot.map(g => g.id);
      const allSelected = ids.every(id => next.has(id));
      if (allSelected) {
        ids.forEach(id => next.delete(id));
      } else {
        ids.forEach(id => next.add(id));
      }
      return next;
    });
  };

  const insertSelectedGroupements = async () => {
    if (selectedGroupementIds.size === 0) return;
    const toInsert = existingGroupements.filter(g => selectedGroupementIds.has(g.id));
    const token = localStorage.getItem('token');
    const API = process.env.REACT_APP_BACKEND_URL;
    let successCount = 0;
    let totalLignes = 0;
    for (const tpl of toInsert) {
      try {
        const payload = {
          nom: tpl.nom,
          lot_id: pickerLotId,
          sous_lot_nom: tpl.sous_lot_nom || null,
          sous_sous_lot_nom: tpl.sous_sous_lot_nom || null,
          lignes: tpl.lignes.map(l => ({
            designation: l.designation, description: l.description || '',
            unite: l.unite || 'U', quantite: l.quantite, prix_unitaire: l.prix_unitaire,
          })),
          save_scope: 'devis',
          enseigne_id: null,
          description: tpl.description || '',
        };
        const r = await axios.post(`${API}/api/devis-maag/${devisId}/insert-groupe`, payload, { headers: { Authorization: `Bearer ${token}` } });
        successCount += 1;
        totalLignes += r.data.count || 0;
      } catch (e) {
        console.warn('Insert-groupe failed for one item, continuing:', e);
      }
    }
    toast.success(`${successCount} groupement${successCount > 1 ? 's' : ''} inséré${successCount > 1 ? 's' : ''} (${totalLignes} lignes)`);
    setSelectedGroupementIds(new Set());
    setShowGroupementsPicker(false);
    loadData();
  };

  // ==================== Import from another devis ====================
  const [showImportModal, setShowImportModal] = useState(false);
  const [importLotId, setImportLotId] = useState(null);
  const [importAvailableDevis, setImportAvailableDevis] = useState([]);
  const [importSelectedDevisId, setImportSelectedDevisId] = useState(null);
  const [importSourceDevis, setImportSourceDevis] = useState(null);
  const [importSelectedPosteIds, setImportSelectedPosteIds] = useState(new Set());
  const [importLoading, setImportLoading] = useState(false);

  const openImportFromDevis = async (lotId) => {
    setImportLotId(lotId);
    setImportSelectedDevisId(null);
    setImportSourceDevis(null);
    setImportSelectedPosteIds(new Set());
    setShowImportModal(true);
    setImportLoading(true);
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      const r = await axios.get(`${API}/api/devis-maag/available-for-copy`, { headers: { Authorization: `Bearer ${token}` } });
      // Exclude current devis
      setImportAvailableDevis((r.data || []).filter(d => d.id !== devisId));
    } catch (e) {
      toast.error('Impossible de charger la liste des devis');
    } finally {
      setImportLoading(false);
    }
  };

  const loadImportSourceDevis = async (sourceDevisId) => {
    setImportSelectedDevisId(sourceDevisId);
    setImportSelectedPosteIds(new Set());
    setImportLoading(true);
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      const r = await axios.get(`${API}/api/devis-maag/${sourceDevisId}`, { headers: { Authorization: `Bearer ${token}` } });
      setImportSourceDevis(r.data);
    } catch (e) {
      toast.error('Impossible de charger ce devis');
    } finally {
      setImportLoading(false);
    }
  };

  const toggleImportPoste = (posteId) => {
    setImportSelectedPosteIds(prev => {
      const next = new Set(prev);
      if (next.has(posteId)) next.delete(posteId); else next.add(posteId);
      return next;
    });
  };

  const toggleImportGroup = (posteIds) => {
    setImportSelectedPosteIds(prev => {
      const next = new Set(prev);
      const allSelected = posteIds.every(id => next.has(id));
      if (allSelected) posteIds.forEach(id => next.delete(id));
      else posteIds.forEach(id => next.add(id));
      return next;
    });
  };

  const confirmImportPostes = async () => {
    if (importSelectedPosteIds.size === 0) return;
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      const r = await axios.post(
        `${API}/api/devis-maag/${devisId}/import-from-devis`,
        { source_devis_id: importSelectedDevisId, poste_ids: Array.from(importSelectedPosteIds) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(`${r.data.imported} ligne${r.data.imported > 1 ? 's' : ''} importée${r.data.imported > 1 ? 's' : ''}`);
      setShowImportModal(false);
      loadData();
    } catch (e) {
      toast.error("Échec import : " + (e.response?.data?.detail || e.message));
    }
  };
  // ==================== End Import from another devis ====================
  const [pickerLotId, setPickerLotId] = useState(null);
  const [existingGroupements, setExistingGroupements] = useState([]);
  const [pickerLoading, setPickerLoading] = useState(false);
  
  const openExistingGroupementsPicker = async (lotId) => {
    setPickerLotId(lotId);
    setShowGroupementsPicker(true);
    setPickerLoading(true);
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      const params = enseigneId ? `?enseigne_id=${enseigneId}&lot_id=${lotId}` : `?lot_id=${lotId}`;
      const r = await axios.get(`${API}/api/groupes-templates${params}`, { headers: { Authorization: `Bearer ${token}` } });
      setExistingGroupements(r.data || []);
    } catch (e) { setExistingGroupements([]); } finally { setPickerLoading(false); }
  };
  
  const insertGroupementFromTemplate = async (tpl) => {
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      const payload = {
        nom: tpl.nom,
        lot_id: pickerLotId,
        sous_lot_nom: tpl.sous_lot_nom || null,
        sous_sous_lot_nom: tpl.sous_sous_lot_nom || null,
        lignes: tpl.lignes.map(l => ({
          designation: l.designation, description: l.description || '',
          unite: l.unite || 'U', quantite: l.quantite, prix_unitaire: l.prix_unitaire,
        })),
        save_scope: 'devis',  // already saved as template, just insert here
        enseigne_id: null,
        description: tpl.description || '',
      };
      const r = await axios.post(`${API}/api/devis-maag/${devisId}/insert-groupe`, payload, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`${r.data.count} prestations ajoutées (${tpl.nom})`);
      setShowGroupementsPicker(false);
      loadData();
    } catch (e) { toast.error("Échec insertion : " + (e.response?.data?.detail || e.message)); }
  };
  const [groupementData, setGroupementData] = useState({
    nom: '',
    description: '',
    lot_id: '',
    lot_nom: '',
    sous_lot_nom: '',
    sous_sous_lot_nom: '',
    save_scope: 'devis', // "devis" | "enseigne" | "maag"
    lignes: [],
  });
  const [newPosteData, setNewPosteData] = useState({
    lot_id: '',
    lot_nom: '',
    designation: '',
    description: '',
    unite: 'U',
    quantite: 1,
    prix_unitaire: 0,
    sous_lot_nom: '',
    sous_sous_lot_nom: '',
    groupe_nom: '',
    is_titre_libre: false,
    scope: 'local', // 'local' | 'maag' | 'enseigne'
    scope_enseigne_id: '',
    addToDevisType: false,
    prix_base_maag: '',
    prix_enseigne: ''
  });
  const [creatingPoste, setCreatingPoste] = useState(false);
  const [enseignes, setEnseignes] = useState([]);
  const [previewCode, setPreviewCode] = useState('');
  const [localisationsList, setLocalisationsList] = useState([]);
  
  // Base MAAG selection state
  const [baseMaagPrestations, setBaseMaagPrestations] = useState([]);
  const [baseMaagSearch, setBaseMaagSearch] = useState('');
  const [showBaseMaagSelector, setShowBaseMaagSelector] = useState(false);
  const [enseigneId, setEnseigneId] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    setPdfUrl(`${process.env.REACT_APP_BACKEND_URL}/api/devis/${devisId}/pdf?token=${token}`);
  }, [devisId]);

  useEffect(() => {
    loadData();
  }, [devisId]);

  useEffect(() => {
    // Load all enseignes once for the scope dropdown
    getEnseignes().then(res => setEnseignes(res.data || [])).catch(() => {});
    // Load localisations list (preset + user-saved, by frequency)
    const token = localStorage.getItem('token');
    axios.get(`${BACKEND}/api/localisations`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setLocalisationsList(r.data.localisations || []))
      .catch(() => {});
  }, []);

  // Fetch a preview of the auto-generated code whenever lot_id / scope changes
  useEffect(() => {
    if (!showNewPosteModal) { setPreviewCode(''); return; }
    if (newPosteData.scope === 'local') { setPreviewCode(''); return; }
    if (!newPosteData.lot_id) { setPreviewCode(''); return; }
    const token = localStorage.getItem('token');
    const params = new URLSearchParams({ lot_id: newPosteData.lot_id });
    if (newPosteData.scope === 'enseigne' && newPosteData.scope_enseigne_id) {
      params.set('enseigne_id', newPosteData.scope_enseigne_id);
    }
    axios.get(`${BACKEND}/api/base-maag/next-code?${params.toString()}`, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(res => setPreviewCode(res.data.code || ''))
      .catch(() => setPreviewCode(''));
  }, [showNewPosteModal, newPosteData.lot_id, newPosteData.scope, newPosteData.scope_enseigne_id]);

  const loadData = async () => {
    try {
      const [devisRes, lotsRes, titresRes] = await Promise.all([
        getDevisById(devisId),
        getLots(),
        getTitresDevis()
      ]);
      setDevis(devisRes.data);
      setLots(lotsRes.data);
      setTitresDevis(titresRes.data);
      
      // Load base MAAG with enseigne prices
      if (devisRes.data.projet_id) {
        try {
          const projetRes = await getProjet(devisRes.data.projet_id);
          setProjet(projetRes.data);
          const eid = projetRes.data.enseigne_id;
          setEnseigneId(eid);
          const baseMaagRes = await getBaseMaagFlat(eid);
          setBaseMaagPrestations(baseMaagRes.data);
        } catch (e) {
          const baseMaagRes = await getBaseMaagFlat();
          setBaseMaagPrestations(baseMaagRes.data);
        }
      }
      
      // Expand lots with postes
      const expanded = {};
      devisRes.data.lots.forEach(lot => {
        if (lot.postes.length > 0) {
          expanded[lot.id] = true;
        }
      });
      setExpandedLots(expanded);
    } catch (e) {
      toast.error('Erreur lors du chargement');
      navigate('/devis');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveDevis = async (field, value) => {
    setSaving(true);
    try {
      await updateDevis(devisId, { [field]: value });
      setDevis(prev => ({ ...prev, [field]: value }));
      toast.success('Devis mis à jour');
    } catch (e) {
      toast.error('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const handleSaveProjetSurface = async (field, value) => {
    if (!devis.projet_id) return;
    setSaving(true);
    try {
      await updateProjet(devis.projet_id, { [field]: value });
      setDevis(prev => ({ ...prev, [field]: value }));
      toast.success('Surface mise à jour');
    } catch (e) {
      toast.error('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const handleAddPoste = async (lotId) => {
    const posteData = newPoste[lotId];
    if (!posteData?.description) {
      toast.error('La description est requise');
      return;
    }

    try {
      await createPoste(devisId, lotId, {
        description: posteData.description,
        unite: posteData.unite || 'U',
        quantite: parseFloat(posteData.quantite) || 0,
        prix_unitaire: parseFloat(posteData.prix_unitaire) || 0
      });
      setNewPoste(prev => ({ ...prev, [lotId]: {} }));
      toast.success('Poste ajouté');
      loadData();
    } catch (e) {
      toast.error('Erreur lors de l\'ajout');
    }
  };

  const handleUpdatePoste = async (posteId) => {
    const posteData = editingPoste;
    if (!posteData) return;

    try {
      await updatePoste(posteId, {
        description: posteData.description,
        unite: posteData.unite,
        quantite: parseFloat(posteData.quantite) || 0,
        prix_unitaire: parseFloat(posteData.prix_unitaire) || 0,
        localisation: posteData.localisation || null,
        commentaire: posteData.commentaire || null
      });
      setEditingPoste(null);
      toast.success('Poste mis à jour');
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la mise à jour');
    }
  };

  const handleUpdateSousLot = async (posteId, sousLotNom) => {
    try {
      await updatePoste(posteId, { 
        sous_lot_nom: sousLotNom || null
      });
      toast.success('Sous-lot mis à jour');
      setEditingSousLot(null);
      setNewSousLotName('');
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la mise à jour');
    }
  };

  // Get existing sous-lots for a lot
  const getExistingSousLots = (lotId) => {
    const lot = devis.lots?.find(l => l.id === lotId);
    if (!lot) return [];
    const sousLots = new Set();
    lot.postes?.forEach(p => {
      if (p.sous_lot_nom) sousLots.add(p.sous_lot_nom);
    });
    return Array.from(sousLots).sort();
  };

  const handleDeletePoste = async (posteId) => {
    if (!window.confirm('Supprimer ce poste ?')) return;
    try {
      await deletePoste(posteId);
      toast.success('Poste supprimé');
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la suppression');
    }
  };

  const handleDuplicatePoste = async (poste) => {
    try {
      await createPoste(devisId, poste.lot_id, {
        description: poste.description,
        unite: poste.unite,
        quantite: poste.quantite,
        prix_unitaire: poste.prix_unitaire,
        sous_lot_nom: poste.sous_lot_nom,
        sous_sous_lot_nom: poste.sous_sous_lot_nom,
        groupe_nom: poste.groupe_nom,
        is_titre_libre: !!poste.is_titre_libre
      });
      toast.success('Prestation dupliquée');
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la duplication');
    }
  };

  const handleMovePoste = async (posteId, direction) => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${BACKEND}/api/postes/${posteId}/move`,
        { direction },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      loadData();
    } catch (e) {
      toast.error('Erreur de déplacement');
    }
  };

  // ---- Drag & drop state & helpers ----
  const [draggingPosteId, setDraggingPosteId] = useState(null);
  const [dragOverKey, setDragOverKey] = useState(null); // `poste-<id>` or `header-<sousLotNom>`

  const onDragStartPoste = (posteId) => (e) => {
    setDraggingPosteId(posteId);
    try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', posteId); } catch (_) {}
  };
  const onDragEnd = () => { setDraggingPosteId(null); setDragOverKey(null); };
  const onDragOverTarget = (key) => (e) => {
    e.preventDefault();
    try { e.dataTransfer.dropEffect = 'move'; } catch (_) {}
    if (dragOverKey !== key) setDragOverKey(key);
  };
  const onDropOnPoste = (targetPoste) => async (e) => {
    e.preventDefault();
    const sourceId = draggingPosteId;
    setDraggingPosteId(null); setDragOverKey(null);
    if (!sourceId || sourceId === targetPoste.id) return;
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${BACKEND}/api/postes/${sourceId}/reorder`, {
        target_sous_lot_nom: targetPoste.sous_lot_nom || null,
        target_sous_sous_lot_nom: targetPoste.sous_sous_lot_nom || null,
        after_poste_id: targetPoste.id
      }, { headers: { Authorization: `Bearer ${token}` } });
      loadData();
    } catch (err) { toast.error("Erreur lors du déplacement"); }
  };
  const onDropOnHeader = (sousLotNom, sousSousLotNom = null) => async (e) => {
    e.preventDefault();
    const sourceId = draggingPosteId;
    setDraggingPosteId(null); setDragOverKey(null);
    if (!sourceId) return;
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${BACKEND}/api/postes/${sourceId}/reorder`, {
        target_sous_lot_nom: sousLotNom || null,
        target_sous_sous_lot_nom: sousSousLotNom || null,
        after_poste_id: null // place at top of this sous-lot
      }, { headers: { Authorization: `Bearer ${token}` } });
      loadData();
    } catch (err) { toast.error("Erreur lors du déplacement"); }
  };

  const handleAddFournisseurDirect = async () => {
    if (!newFD.designation) {
      toast.error('La désignation est requise');
      return;
    }
    if (!devis?.projet_id) {
      toast.error('Projet introuvable');
      return;
    }
    try {
      const created = await createFournisseurDirect({
        projet_id: devis.projet_id,
        designation: newFD.designation,
        categorie: newFD.categorie,
        payeur: newFD.payeur,
        montant_ht: parseFloat(newFD.montant_ht) || 0
      });
      setNewFD({ designation: '', categorie: 'intervenants', payeur: '', montant_ht: '' });
      if (Array.isArray(devis.fd_selection) && created?.data?.id) {
        await updateDevis(devisId, { fd_selection: [...devis.fd_selection, created.data.id] });
      }
      toast.success('Fournisseur direct ajouté');
      loadData();
    } catch (e) {
      toast.error('Erreur lors de l\'ajout');
    }
  };

  const handleDeleteFournisseurDirect = async (fdId) => {
    if (!window.confirm('Supprimer ce fournisseur direct ?')) return;
    try {
      await deleteFournisseurDirect(fdId);
      toast.success('Supprimé');
      loadData();
    } catch (e) {
      toast.error('Erreur');
    }
  };

  const handleResyncFournisseurs = async () => {
    if (!devis?.projet_id) return;
    if (!window.confirm('Resynchroniser les fournisseurs directs depuis la Base MAAG ?\n\nCette action ajoutera les nouveaux fournisseurs de la base qui ne sont pas encore dans le projet.')) return;
    setResyncingFD(true);
    try {
      const response = await resyncProjetFromBase(devis.projet_id);
      if (response.data.added_count > 0) {
        toast.success(response.data.message);
      } else {
        toast.info('Aucun nouveau fournisseur à ajouter. Déjà à jour.');
      }
      loadData();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de la synchronisation');
    } finally {
      setResyncingFD(false);
    }
  };

  const handleBulkDeleteFD = async () => {
    if (selectedFDs.size === 0) return;
    if (!window.confirm(`Supprimer ${selectedFDs.size} fournisseur(s) direct(s) ?`)) return;
    try {
      // Single API call instead of N parallel calls (gain: 25s -> ~300ms for 18 items)
      const res = await bulkDeleteFournisseursDirects([...selectedFDs]);
      toast.success(`${res.data.deleted} fournisseur(s) supprimé(s)`);
      setSelectedFDs(new Set());
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la suppression');
    }
  };

  const toggleFDSelection = (id) => {
    setSelectedFDs(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const toggleAllFDsInCategory = (categorie) => {
    const fds = fdVisible.filter(fd => fd.categorie === categorie);
    const allSelected = fds.every(fd => selectedFDs.has(fd.id));
    setSelectedFDs(prev => {
      const next = new Set(prev);
      fds.forEach(fd => allSelected ? next.delete(fd.id) : next.add(fd.id));
      return next;
    });
  };

  const handleUpdateFDField = async (fd, field, value) => {
    if (isLocked) return;
    if (value === (fd[field] || '')) return;
    try {
      await updateFournisseurDirect(fd.id, { ...fd, [field]: field === 'montant_ht' ? (parseFloat(value) || 0) : value });
      if (field === 'montant_ht') toast.success('Montant mis à jour');
      loadData();
    } catch (err) {
      toast.error('Erreur de mise à jour');
    }
  };

  const PDF_LANGS = [
    { code: 'fr', label: 'Français', flag: '🇫🇷' },
    { code: 'en', label: 'English', flag: '🇬🇧' },
    { code: 'es', label: 'Español', flag: '🇪🇸' },
    { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  ];
  const [pdfLang, setPdfLang] = useState('fr');
  useEffect(() => { if (devis?.langue_pdf) setPdfLang(devis.langue_pdf); }, [devis?.langue_pdf]);

  const handlePdfLangChange = async (code) => {
    setPdfLang(code);
    try {
      await updateDevis(devisId, { langue_pdf: code });
      const l = PDF_LANGS.find(x => x.code === code);
      toast.success(code === 'fr' ? 'PDF en français' : `PDF traduit en ${l?.label} par IA à l'aperçu`);
    } catch (e) {
      toast.error('Impossible de mémoriser la langue');
    }
  };

  const showFD = devis?.afficher_fournisseurs_directs !== false;
  const fdAll = devis?.fournisseurs_directs || [];
  const fdSelection = Array.isArray(devis?.fd_selection) ? devis.fd_selection : null;
  const fdVisible = fdSelection ? fdAll.filter(fd => fdSelection.includes(fd.id)) : fdAll;
  const [fdPickerOpen, setFdPickerOpen] = useState(false);
  const [fdPickerIds, setFdPickerIds] = useState(new Set());

  const applyFDSettings = async (payload, msg) => {
    try {
      const res = await updateDevis(devisId, payload);
      setDevis(res.data);
      setFdPickerOpen(false);
      if (msg) toast.success(msg);
    } catch (e) {
      toast.error('Impossible de modifier ce réglage');
    }
  };
  const handleInsertAllFD = () => applyFDSettings({ afficher_fournisseurs_directs: true, fd_selection: null }, `${fdAll.length} fournisseurs directs insérés dans le devis`);
  const openFDPicker = () => { setFdPickerIds(new Set(fdSelection || [])); setFdPickerOpen(true); };
  const handleConfirmFDPicker = () => {
    const ids = [...fdPickerIds];
    if (ids.length === 0) return toast.error('Sélectionnez au moins un fournisseur direct');
    applyFDSettings({ afficher_fournisseurs_directs: true, fd_selection: ids.length === fdAll.length ? null : ids }, `${ids.length} fournisseur(s) direct(s) inséré(s) dans le devis`);
  };
  const toggleFDPickerId = (id) => setFdPickerIds(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });

  const handleToggleFD = async () => {
    const next = !showFD;
    try {
      const res = await updateDevis(devisId, { afficher_fournisseurs_directs: next });
      setDevis(res.data);
      toast.success(next ? 'Fournisseurs directs affichés sur le devis et le PDF' : 'Fournisseurs directs masqués : le PDF ne montrera que les lots MAAG');
    } catch (e) {
      toast.error('Impossible de modifier ce réglage');
    }
  };

  // Nom du fichier PDF : « AAAA-MM-JJ - ENSEIGNE - VILLE - Objet » sans doublon si l'objet suit déjà la convention
  const buildPdfFilename = () => {
    const dateStr = (devis?.date_creation || devis?.created_at || '').slice(0, 10) || new Date().toISOString().slice(0, 10);
    const enseigne = (projet?.enseigne_nom || '').toUpperCase().trim();
    const ville = (projet?.ville || '').toUpperCase().trim();
    const objet = (devis?.objet || `Devis ${devis?.numero_devis || ''}`).trim();
    const objetUp = objet.toUpperCase();
    const dejaPrefixe = enseigne && objetUp.startsWith(enseigne) && (!ville || objetUp.includes(ville));
    const parts = dejaPrefixe ? [dateStr, objet] : [dateStr, [enseigne, ville].filter(Boolean).join(' - '), objet];
    const langSuffix = pdfLang !== 'fr' ? ` (${pdfLang.toUpperCase()})` : '';
    return `${parts.filter(Boolean).join(' - ')}${langSuffix}.pdf`.replace(/[\\/:*?"<>|]/g, '_').replace(/\s+/g, ' ');
  };
  const [pdfNameDialog, setPdfNameDialog] = useState(null); // { fname }
  const handleExportPdf = () => setPdfNameDialog({ fname: buildPdfFilename() });
  const confirmExportPdf = () => {
    let fname = (pdfNameDialog?.fname || '').trim().replace(/[\\/:*?"<>|]/g, '_');
    if (!fname) return toast.error('Indiquez un nom de fichier');
    if (!/\.pdf$/i.test(fname)) fname += '.pdf';
    const langSuffix = pdfLang !== 'fr' ? ` (${pdfLang.toUpperCase()})` : '';
    setPdfNameDialog(null);
    openPdfPreview(
      `/devis/${devisId}/pdf?lang=${pdfLang}`,
      { title: `Devis ${devis?.numero_devis || ''} — ${devis?.objet || ''}${langSuffix}`.trim(), filename: fname }
    );
  };

  const toggleLot = (lotId) => {
    setExpandedLots(prev => ({
      ...prev,
      [lotId]: !prev[lotId]
    }));
  };

  // Selection handlers
  const toggleSelectPoste = (posteId) => {
    setSelectedPostes(prev => {
      const newSet = new Set(prev);
      if (newSet.has(posteId)) {
        newSet.delete(posteId);
      } else {
        newSet.add(posteId);
      }
      return newSet;
    });
  };

  const selectAllInLot = (lot) => {
    const lotPosteIds = lot.postes.map(p => p.id);
    const allSelected = lotPosteIds.every(id => selectedPostes.has(id));
    
    setSelectedPostes(prev => {
      const newSet = new Set(prev);
      if (allSelected) {
        lotPosteIds.forEach(id => newSet.delete(id));
      } else {
        lotPosteIds.forEach(id => newSet.add(id));
      }
      return newSet;
    });
  };

  const handleClearLot = async (lotId, lotNom) => {
    if (!window.confirm(`Vider le lot "${lotNom}" de ce devis ?\n\n⚠️ Cela n'affecte PAS la Base MAAG ni l'enseigne.`)) return;
    
    setIsDeleting(true);
    try {
      await clearLotPostes(devisId, lotId);
      toast.success(`Lot "${lotNom}" vidé`);
      setSelectedPostes(new Set());
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la suppression');
    } finally {
      setIsDeleting(false);
    }
  };

  // ---- Lots MAAG personnalisés (par devis) ----
  const [editingLotId, setEditingLotId] = useState(null);
  const [editingLotNom, setEditingLotNom] = useState('');
  const [newLotNom, setNewLotNom] = useState('');
  const [showAddLot, setShowAddLot] = useState(false);
  const hasCustomLots = devis?.lots && (devis.lots.length !== 18 || devis.lots.some((l, i) => l.id !== lots[i]?.id || l.nom !== lots[i]?.nom));

  const startRenameLot = (lot) => { setEditingLotId(lot.id); setEditingLotNom(lot.nom); };

  const handleRenameLot = async () => {
    const nom = editingLotNom.trim();
    if (!nom) { toast.error('Le nom du lot ne peut pas être vide'); return; }
    try {
      const res = await renameDevisLot(devisId, editingLotId, nom);
      setDevis(res.data);
      setEditingLotId(null);
      toast.success('Lot renommé');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors du renommage');
    }
  };

  const handleDeleteLot = async (lot) => {
    const nb = lot.postes.length;
    const msg = nb > 0
      ? `Supprimer le lot "${lot.id}. ${lot.nom}" ?\n\n⚠️ Ce lot contient ${nb} poste(s) qui seront définitivement supprimés de ce devis.`
      : `Supprimer le lot "${lot.id}. ${lot.nom}" de ce devis ?`;
    if (!window.confirm(msg)) return;
    try {
      const res = await deleteDevisLot(devisId, lot.id);
      setDevis(res.data);
      setSelectedPostes(new Set());
      toast.success(`Lot "${lot.nom}" supprimé`);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de la suppression du lot');
    }
  };

  const handleAddLot = async () => {
    const nom = newLotNom.trim();
    if (!nom) { toast.error('Le nom du lot ne peut pas être vide'); return; }
    try {
      const res = await addDevisLot(devisId, nom);
      setDevis(res.data);
      const added = res.data.lots[res.data.lots.length - 1];
      if (added) setExpandedLots((prev) => ({ ...prev, [added.id]: true }));
      setNewLotNom('');
      setShowAddLot(false);
      toast.success(`Lot "${nom.toUpperCase()}" ajouté`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erreur lors de l'ajout du lot");
    }
  };

  const handleResetLots = async () => {
    if (!window.confirm('Réinitialiser les 18 lots MAAG standards ?\n\n⚠️ Les lots ajoutés (et leurs postes) seront supprimés, les noms reviendront aux valeurs par défaut.')) return;
    try {
      const res = await resetDevisLots(devisId);
      setDevis(res.data);
      toast.success('Lots réinitialisés');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur lors de la réinitialisation');
    }
  };

  const handleBulkDelete = async () => {
    if (selectedPostes.size === 0) return;
    if (!window.confirm(`Supprimer ${selectedPostes.size} poste(s) de ce devis ?`)) return;
    
    setIsDeleting(true);
    try {
      await bulkDeletePostes(devisId, Array.from(selectedPostes));
      toast.success(`${selectedPostes.size} poste(s) supprimé(s)`);
      setSelectedPostes(new Set());
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la suppression');
    } finally {
      setIsDeleting(false);
    }
  };

  const openEditPosteFull = (poste, lot) => {
    // Extract TITRE / description heuristiquement si la description contient " - "
    const fullDesc = poste.description || '';
    const idx = fullDesc.indexOf(' - ');
    let titre = '';
    let desc = fullDesc;
    if (idx > 0 && idx < 200) {
      titre = fullDesc.substring(0, idx);
      desc = fullDesc.substring(idx + 3);
    } else {
      titre = fullDesc.split('\n')[0].substring(0, 120);
      desc = fullDesc;
    }
    setEditingPosteId(poste.id);
    setNewPosteData({
      lot_id: poste.lot_id,
      lot_nom: lot?.nom || '',
      designation: titre,
      description: desc,
      unite: poste.unite || 'U',
      quantite: poste.quantite || 1,
      prix_unitaire: poste.prix_unitaire || 0,
      sous_lot_nom: poste.sous_lot_nom || '',
      sous_sous_lot_nom: poste.sous_sous_lot_nom || '',
      groupe_nom: poste.groupe_nom || '',
      is_titre_libre: !!poste.is_titre_libre,
      scope: 'local', // Par défaut local — l'utilisateur peut promouvoir
      scope_enseigne_id: enseigneId || '',
      addToDevisType: false,
      prix_base_maag: '',
      prix_enseigne: '',
      from_catalog_id: poste.code_base_maag ? 'existing' : null,
      localisation: poste.localisation || '',
      commentaire: poste.commentaire || ''
    });
    setShowNewPosteModal(true);
  };

  const openNewGroupementModal = async (lotId) => {
    const lot = (devis?.lots || lots).find(l => l.id === lotId);
    setGroupementData({
      nom: '',
      description: '',
      lot_id: lotId,
      lot_nom: lot?.nom || '',
      sous_lot_nom: '',
      sous_sous_lot_nom: '',
      save_scope: 'devis',
      lignes: [
        { designation: '', description: '', unite: 'U', quantite: 1, prix_unitaire: 0 },
        { designation: '', description: '', unite: 'U', quantite: 1, prix_unitaire: 0 },
        { designation: '', description: '', unite: 'U', quantite: 1, prix_unitaire: 0 },
      ],
    });
    setShowGroupementModal(true);
    // Load sous-lots templates for this lot (backend seeds defaults if empty)
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      const r = await axios.get(`${API}/api/sous-lots-templates?lot_id=${lotId}`, { headers: { Authorization: `Bearer ${token}` } });
      setSousLotsTemplates(r.data || []);
    } catch (e) {
      setSousLotsTemplates([]);
    }
  };
  
  const aiCorrectGroupementLignes = async () => {
    const hasContent = groupementData.lignes.some(l => (l.designation || '').trim() || (l.description || '').trim());
    if (!hasContent) {
      toast.error("Saisissez au moins 1 ligne (désignation ou description) avant de lancer l'IA");
      return;
    }
    setGroupementLoading(true);
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      // Only send lines with content (IA will correct these, keeping others untouched)
      const linesToSend = groupementData.lignes.map(l => ({
        designation: l.designation || '',
        description: l.description || '',
        unite: l.unite || 'U',
        quantite: parseFloat(l.quantite) || 1,
        prix_unitaire: parseFloat(l.prix_unitaire) || 0,
      })).filter(l => (l.designation || l.description).trim());
      
      const r = await axios.post(`${API}/api/ai/generate-groupe-lignes`, {
        nom_groupe: groupementData.nom || groupementData.sous_lot_nom || '',
        context: `Lot ${groupementData.lot_nom}${groupementData.sous_lot_nom ? ' / ' + groupementData.sous_lot_nom : ''}`,
        lignes: linesToSend,
      }, { headers: { Authorization: `Bearer ${token}` }, timeout: 60000 });
      
      const correctedList = r.data.lignes || [];
      // Merge: replace lines with corrected designation/description (keeping numbers), leave empty lines untouched
      let ci = 0;
      const newLignes = groupementData.lignes.map(l => {
        if ((l.designation || l.description || '').trim()) {
          const c = correctedList[ci++];
          if (c) {
            return {
              ...l,
              designation: c.designation || l.designation,
              description: c.description || l.description,
              // unite / quantite / prix_unitaire preserved
            };
          }
        }
        return l;
      });
      setGroupementData(prev => ({ ...prev, lignes: newLignes }));
      toast.success(`${correctedList.length} ligne(s) corrigée(s) par l'IA`);
    } catch (e) {
      toast.error("Échec IA : " + (e.response?.data?.detail || e.message));
    } finally {
      setGroupementLoading(false);
    }
  };
  
  const updateGroupementLigne = (idx, field, value) => {
    setGroupementData(prev => ({
      ...prev,
      lignes: prev.lignes.map((l, i) => i === idx ? { ...l, [field]: value } : l),
    }));
  };
  
  const fillGroupementLigneFromBaseMaag = (idx, prestation) => {
    // Extract title (before " - ") from description if possible
    const desc = prestation.description || '';
    let desig = prestation.designation || prestation.nom || '';
    let shortDesc = desc;
    if (!desig && desc.includes(' - ')) {
      const parts = desc.split(' - ');
      desig = parts[0];
      shortDesc = parts.slice(1).join(' - ');
    }
    // Prefer enseigne-specific price, then base_maag price
    const pu = prestation.prix_enseigne || prestation.prix_base_maag || prestation.prix_unitaire || 0;
    setGroupementData(prev => ({
      ...prev,
      lignes: prev.lignes.map((l, i) => i === idx ? {
        ...l,
        designation: (desig || '').toUpperCase(),
        description: shortDesc || '',
        unite: prestation.unite || 'U',
        quantite: prestation.quantite_defaut || l.quantite || 1,
        prix_unitaire: pu,
      } : l),
    }));
    setGroupementPickerIdx(null);
    setGroupementPickerSearch('');
    toast.success("Prestation chargée depuis Base MAAG");
  };
  
  const addGroupementLigne = () => {
    setGroupementData(prev => ({ ...prev, lignes: [...prev.lignes, { designation: '', description: '', unite: 'U', quantite: 1, prix_unitaire: 0 }] }));
  };
  
  const removeGroupementLigne = (idx) => {
    setGroupementData(prev => ({ ...prev, lignes: prev.lignes.filter((_, i) => i !== idx) }));
  };
  
  const submitGroupement = async () => {
    const validLignes = groupementData.lignes.filter(l => l.designation.trim());
    if (!groupementData.nom.trim()) { toast.error("Le nom du groupement est obligatoire"); return; }
    if (!groupementData.sous_lot_nom) { toast.error("Sélectionnez un sous-lot"); return; }
    if (validLignes.length === 0) { toast.error("Ajoutez au moins 1 ligne avec désignation"); return; }
    setGroupementLoading(true);
    try {
      const token = localStorage.getItem('token');
      const API = process.env.REACT_APP_BACKEND_URL;
      const payload = {
        nom: groupementData.nom.trim(),
        lot_id: groupementData.lot_id,
        sous_lot_nom: groupementData.sous_lot_nom || null,
        sous_sous_lot_nom: groupementData.sous_sous_lot_nom || null,
        lignes: validLignes.map(l => ({
          designation: l.designation,
          description: l.description || '',
          unite: l.unite || 'U',
          quantite: parseFloat(l.quantite) || 1,
          prix_unitaire: parseFloat(l.prix_unitaire) || 0,
        })),
        save_scope: groupementData.save_scope,
        enseigne_id: enseigneId || null,
        description: groupementData.description || '',
      };
      const r = await axios.post(`${API}/api/devis-maag/${devisId}/insert-groupe`, payload, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`${r.data.count} prestations ajoutées` + (r.data.template_id ? ' + groupement sauvegardé' : ''));
      setShowGroupementModal(false);
      loadData();
    } catch (e) {
      toast.error("Échec insertion : " + (e.response?.data?.detail || e.message));
    } finally {
      setGroupementLoading(false);
    }
  };

  const openNewPosteModal = (lotId, sousLotNom = '', sousSousLotNom = '', groupeNom = '', isTitreLibre = false) => {
    const lot = (devis?.lots || lots).find(l => l.id === lotId);
    // Load sous-lots templates in background
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const API = process.env.REACT_APP_BACKEND_URL;
        const r = await axios.get(`${API}/api/sous-lots-templates?lot_id=${lotId}`, { headers: { Authorization: `Bearer ${token}` } });
        setSousLotsTemplates(r.data || []);
      } catch (e) { setSousLotsTemplates([]); }
    })();
    setNewPosteData({
      lot_id: lotId,
      lot_nom: lot?.nom || '',
      designation: '',
      description: '',
      unite: 'U',
      quantite: 1,
      prix_unitaire: 0,
      sous_lot_nom: sousLotNom || '',
      sous_sous_lot_nom: sousSousLotNom || '',
      groupe_nom: groupeNom || '',
      is_titre_libre: !!isTitreLibre,
      scope: 'local',
      scope_enseigne_id: enseigneId || '',
      addToDevisType: false,
      prix_base_maag: '',
      prix_enseigne: '',
      from_catalog_id: null,
      localisation: '',
      commentaire: ''
    });
    if (sousLotNom) {
      setShowBaseMaagSelector(true);
      setBaseMaagSearch('');
    }
    setShowNewPosteModal(true);
  };

  const handleCreatePosteWithEnrichment = async () => {
    if (!newPosteData.designation) {
      toast.error('La désignation est requise');
      return;
    }
    
    // EDIT MODE: update the existing poste + optionally promote to catalog
    if (editingPosteId) {
      setCreatingPoste(true);
      try {
        const combinedDesc = newPosteData.description
          ? `${newPosteData.designation} - ${newPosteData.description}`
          : newPosteData.designation;
        await updatePoste(editingPosteId, {
          description: combinedDesc,
          unite: newPosteData.unite,
          quantite: parseFloat(newPosteData.quantite) || 1,
          prix_unitaire: parseFloat(newPosteData.prix_unitaire) || 0,
          sous_lot_nom: newPosteData.sous_lot_nom || null,
          sous_sous_lot_nom: newPosteData.sous_sous_lot_nom || '',
          groupe_nom: newPosteData.groupe_nom || '',
          is_titre_libre: !!newPosteData.is_titre_libre,
          localisation: newPosteData.localisation || null,
          commentaire: newPosteData.commentaire || null
        });
        
        // If user chose to promote to catalog (scope != local) AND poste wasn't already linked
        if (newPosteData.scope !== 'local' && newPosteData.from_catalog_id !== 'existing') {
          const selectedEnseigneId = newPosteData.scope === 'enseigne' ? (newPosteData.scope_enseigne_id || null) : null;
          if (newPosteData.scope === 'enseigne' && !selectedEnseigneId) {
            toast.error("Veuillez choisir une enseigne");
            setCreatingPoste(false);
            return;
          }
          const token = localStorage.getItem('token');
          const r = await axios.post(`${BACKEND}/api/postes/${editingPosteId}/promote-to-catalog`, {
            lot_id: newPosteData.lot_id,
            designation: newPosteData.designation,
            description: newPosteData.description,
            unite: newPosteData.unite,
            enseigne_id: selectedEnseigneId,
            prix_base_maag: newPosteData.prix_base_maag ? parseFloat(newPosteData.prix_base_maag) : null,
            prix_enseigne: newPosteData.prix_enseigne ? parseFloat(newPosteData.prix_enseigne) : null
          }, { headers: { Authorization: `Bearer ${token}` } });
          toast.success(`Prestation modifiée + ajoutée au catalogue (${r.data.code})`);
        } else {
          toast.success('Prestation modifiée');
        }
        setShowNewPosteModal(false);
        setEditingPosteId(null);
        loadData();
      } catch (e) {
        toast.error('Erreur lors de la modification');
        console.error(e);
      } finally {
        setCreatingPoste(false);
      }
      return;
    }
    
    // CREATE MODE (existing logic below)
    // If article picked from catalog → never create a catalog copy, never touch prix_enseigne
    const fromCatalog = !!newPosteData.from_catalog_id;
    const effectiveScope = fromCatalog ? 'local' : newPosteData.scope;
    const addToBaseMaag = !fromCatalog && effectiveScope !== 'local';
    const selectedEnseigneId = (!fromCatalog && effectiveScope === 'enseigne') ? (newPosteData.scope_enseigne_id || null) : null;
    if (!fromCatalog && effectiveScope === 'enseigne' && !selectedEnseigneId) {
      toast.error("Veuillez choisir une enseigne");
      return;
    }
    
    setCreatingPoste(true);
    try {
      const result = await createPosteWithEnrichment(devisId, {
        lot_id: newPosteData.lot_id,
        designation: newPosteData.designation,
        description: newPosteData.description,
        unite: newPosteData.unite,
        quantite: parseFloat(newPosteData.quantite) || 1,
        prix_unitaire: parseFloat(newPosteData.prix_unitaire) || 0,
        sous_lot_nom: newPosteData.sous_lot_nom || null,
        sous_sous_lot_nom: newPosteData.sous_sous_lot_nom || null,
        groupe_nom: newPosteData.groupe_nom || null,
        is_titre_libre: !!newPosteData.is_titre_libre,
        add_to_base_maag: addToBaseMaag,
        add_to_devis_type: !fromCatalog && newPosteData.addToDevisType,
        prix_base_maag: (!fromCatalog && newPosteData.prix_base_maag) ? parseFloat(newPosteData.prix_base_maag) : null,
        prix_enseigne: (!fromCatalog && newPosteData.prix_enseigne) ? parseFloat(newPosteData.prix_enseigne) : null,
        enseigne_id: selectedEnseigneId
      });
      
      // Build success message
      let message = 'Prestation créée';
      if (result.data.enrichment.base_maag_created) {
        message += ` + catalogue (${result.data.enrichment.base_maag_code})`;
      }
      if (result.data.enrichment.prix_enseigne_created) {
        message += ' + prix enseigne';
      }
      if (result.data.enrichment.devis_type_created) {
        message += ' + devis type';
      }
      
      // If user picked from catalog, modified the text and wants to propagate
      if (fromCatalog && newPosteData.updateCatalog && newPosteData.from_catalog_id && newPosteData.from_catalog_id !== 'existing') {
        try {
          await updateBaseMaagPrestation(newPosteData.from_catalog_id, {
            designation: newPosteData.designation,
            description: newPosteData.description,
            unite: newPosteData.unite,
            prix_maag: parseFloat(newPosteData.prix_unitaire) || 0
          });
          message += ' + Base MAAG mise à jour';
        } catch (err) {
          toast.error("Échec de la mise à jour du catalogue");
        }
      }
      
      toast.success(message);
      
      setShowNewPosteModal(false);
      loadData();
    } catch (e) {
      toast.error('Erreur lors de la création');
      console.error(e);
    } finally {
      setCreatingPoste(false);
    }
  };

  const formatMoney = (value) => {
    return new Intl.NumberFormat('fr-FR', { 
      style: 'currency', 
      currency: 'EUR',
      minimumFractionDigits: 2
    }).format(value);
  };

  // Check if devis is locked (signed)
  const isLocked = devis?.statut === 'signe';

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-4 border-slate-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  const surfaceTotal = (devis.surface_commerciale || 0) + (devis.surface_annexes || 0);
  const ratioMaag = surfaceTotal > 0 ? devis.total_ht_maag / surfaceTotal : 0;
  const ratioTotal = surfaceTotal > 0 ? devis.total_ht / surfaceTotal : 0;

  return (
    <div data-testid="devis-edit-page">
      <div className="mb-6 flex items-center justify-between">
        <Link 
          to={`/projets/${devis.projet_id}`}
          className="inline-flex items-center text-sm text-slate-500 hover:text-slate-900"
        >
          <ArrowLeft className="w-4 h-4 mr-1" />
          Retour au projet
        </Link>
        <div className="flex items-center gap-2">
          <Link
            to={`/projets/${devis.projet_id}?tab=marge`}
            data-testid="view-sortie-btn"
            className="flex items-center px-4 py-2 border border-slate-300 text-slate-700 rounded-md font-medium hover:bg-slate-50 transition-colors"
          >
            <BarChart3 className="w-4 h-4 mr-2" />
            Voir marge
          </Link>
          <div className="flex items-center rounded-md border border-slate-300 bg-white overflow-hidden" title="Langue d'export du PDF (le devis reste en français, la traduction est faite par IA à l'aperçu)">
            <span className="pl-2.5 pr-1.5 text-slate-500"><Globe className="w-4 h-4" /></span>
            <select
              value={pdfLang}
              onChange={(e) => handlePdfLangChange(e.target.value)}
              className="h-9 pr-8 pl-1 bg-transparent text-sm text-slate-700 font-medium focus:outline-none cursor-pointer"
              data-testid="pdf-lang-select"
            >
              {PDF_LANGS.map(l => <option key={l.code} value={l.code}>{l.flag} {l.label}</option>)}
            </select>
          </div>
          <button
            data-testid="export-pdf-btn"
            className="flex items-center px-4 py-2 bg-slate-900 text-white rounded-md font-medium hover:bg-slate-800 transition-colors"
            onClick={handleExportPdf}
          >
            <Download className="w-4 h-4 mr-2" />
            Aperçu PDF{pdfLang !== 'fr' ? ` · ${pdfLang.toUpperCase()}` : ''}
          </button>
        </div>
      </div>

      {/* Header */}
      <div className="bg-white rounded-lg border border-slate-200 p-6 shadow-sm mb-6">
        {/* Signed devis lock banner */}
        {isLocked && (
          <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center gap-3">
              <div className="flex-shrink-0">
                <Lock className="w-6 h-6 text-green-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-semibold text-green-800">Devis signé - Lecture seule</h3>
                <p className="text-sm text-green-700 mt-1">
                  Ce devis a été signé{devis.signataire_nom ? ` par ${devis.signataire_nom}` : ''}{devis.date_signature ? ` le ${devis.date_signature}` : ''}. 
                  Il ne peut plus être modifié. Pour créer une nouvelle version, retournez à la liste des devis et cliquez sur "Dupliquer pour V2".
                </p>
              </div>
              <div className="flex-shrink-0">
                <CheckCircle className="w-8 h-8 text-green-500" />
              </div>
            </div>
          </div>
        )}
        
        <div className="flex items-start justify-between mb-6">
          <div>
            <div className="flex items-center mb-2">
              <FileText className="w-6 h-6 text-orange-500 mr-2" />
              <h1 className="text-2xl font-bold text-slate-900">{devis.objet}</h1>
            </div>
            <p className="text-slate-500">Client: {devis.client_nom}</p>
          </div>
          <div className="text-right">
            <p className="text-sm text-slate-500">Version {devis.version}</p>
            <div className="flex items-center justify-end gap-2 mt-1">
              <label className="text-xs text-slate-500">Date :</label>
              <input
                type="date"
                value={devis.date_remise || ''}
                onChange={(e) => handleSaveDevis('date_remise', e.target.value)}
                disabled={isLocked}
                className={`h-8 px-2 rounded-md border border-slate-300 bg-white text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-900 ${isLocked ? 'bg-slate-100 cursor-not-allowed' : ''}`}
                data-testid="devis-date-remise-input"
                title="Date du devis — clique pour modifier"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">Surface commerciale (m²)</label>
            <input
              type="number"
              value={devis.surface_commerciale || ''}
              onChange={(e) => handleSaveProjetSurface('surface_commerciale', parseFloat(e.target.value) || 0)}
              disabled={isLocked}
              className={`w-full h-9 px-3 rounded-md border border-slate-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 ${isLocked ? 'bg-slate-100 cursor-not-allowed' : ''}`}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">Surface annexes (m²)</label>
            <input
              type="number"
              value={devis.surface_annexes || ''}
              onChange={(e) => handleSaveProjetSurface('surface_annexes', parseFloat(e.target.value) || 0)}
              disabled={isLocked}
              className={`w-full h-9 px-3 rounded-md border border-slate-300 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 ${isLocked ? 'bg-slate-100 cursor-not-allowed' : ''}`}
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">Surface totale</label>
            <div className="h-9 px-3 rounded-md bg-slate-100 flex items-center text-sm font-mono">
              {surfaceTotal} m²
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">Ratio MAAG €/m²</label>
            <div className="h-9 px-3 rounded-md bg-slate-100 flex items-center text-sm font-mono">
              {formatMoney(ratioMaag)}
            </div>
          </div>
        </div>

        {/* Titre du devis pour le PDF */}
        <div className="mt-4 pt-4 border-t border-slate-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Type className="w-4 h-4 text-slate-400" />
              <span className="text-sm font-medium text-slate-700">Titre du PDF :</span>
              <span className="text-sm text-slate-900 font-semibold">
                {devis.titre_devis_custom || titresDevis.find(t => t.code === devis.titre_devis)?.titre || 'DEVIS ESTIMATIF'}
              </span>
            </div>
            {!isLocked && (
              <button
                onClick={() => setShowTitreModal(true)}
                className="text-sm text-indigo-600 hover:text-indigo-800 font-medium"
              >
                Modifier
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Synthèse MAAG */}
      <div className="bg-white rounded-lg border border-slate-200 shadow-sm mb-6 overflow-hidden">
        <div className="bg-slate-900 text-white px-6 py-4">
          <h2 className="text-lg font-semibold flex items-center">
            <Calculator className="w-5 h-5 mr-2" />
            LOTS MAAG
          </h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-slate-500">N°</th>
                <th className="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider text-slate-500">Lot</th>
                <th className="px-6 py-3 text-right text-xs font-bold uppercase tracking-wider text-slate-500">Total HT</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {devis.lots.map((lot) => (
                <tr
                  key={lot.id}
                  onClick={() => {
                    const el = document.querySelector(`[data-testid="lot-${lot.id}"]`);
                    if (el) {
                      // Auto-expand the lot if it's collapsed so the user lands on its content
                      if (!expandedLots[lot.id]) {
                        setExpandedLots((prev) => ({ ...prev, [lot.id]: true }));
                      }
                      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                      // Subtle highlight to confirm the navigation
                      el.classList.add('ring-2', 'ring-orange-400');
                      setTimeout(() => el.classList.remove('ring-2', 'ring-orange-400'), 1500);
                    }
                  }}
                  className="hover:bg-orange-50 cursor-pointer transition-colors"
                  data-testid={`lot-recap-row-${lot.id}`}
                  title="Cliquer pour aller au détail de ce lot"
                >
                  <td className="px-6 py-3 text-sm text-slate-500 w-12">{lot.id}</td>
                  <td className="px-6 py-3 text-sm text-slate-700 font-medium underline decoration-dotted decoration-slate-300">{lot.nom}</td>
                  <td className="px-6 py-3 text-sm text-slate-900 text-right font-mono">{formatMoney(lot.total_ht)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-slate-50 border-t-2 border-slate-200">
              <tr>
                <td colSpan="2" className="px-6 py-3 text-sm font-bold text-slate-900">TOTAL LOTS MAAG HT</td>
                <td className="px-6 py-3 text-sm font-bold text-slate-900 text-right font-mono">{formatMoney(devis.total_ht_maag)}</td>
              </tr>
              <tr>
                <td colSpan="2" className="px-6 py-3 text-sm text-slate-600">TVA 20%</td>
                <td className="px-6 py-3 text-sm text-slate-600 text-right font-mono">{formatMoney(devis.tva)}</td>
              </tr>
              <tr className="bg-slate-900 text-white">
                <td colSpan="2" className="px-6 py-3 text-sm font-bold">TOTAL LOTS MAAG TTC</td>
                <td className="px-6 py-3 text-sm font-bold text-right font-mono">{formatMoney(devis.total_ht_maag + devis.tva)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Fournisseurs Directs */}
      <div className={`bg-white rounded-lg border border-slate-200 shadow-sm mb-6 overflow-hidden ${!showFD ? 'opacity-80' : ''}`} data-testid="fd-section">
        <div className={`${showFD ? 'bg-orange-500' : 'bg-slate-500'} text-white px-6 py-4 transition-colors`}>
          <div className="flex items-center justify-between gap-4">
            <div>
              <h2 className="text-lg font-semibold flex items-center">
                <Truck className="w-5 h-5 mr-2" />
                FOURNISSEURS DIRECTS (payés par le client)
              </h2>
              <p className={`text-sm mt-1 ${showFD ? 'text-orange-100' : 'text-slate-200'}`}>
                {showFD
                  ? (fdSelection ? `${fdVisible.length} sur ${fdAll.length} fournisseurs directs affichés sur ce devis` : 'Cliquez sur un montant pour le modifier')
                  : 'Non insérés sur ce devis : absents du PDF et du budget total (aucune donnée supprimée)'}
              </p>
            </div>
            {!isLocked && !showFD && (
              <div className="flex items-center gap-2 shrink-0">
                <button type="button" onClick={handleInsertAllFD} data-testid="fd-insert-all-btn" className="flex items-center gap-1.5 px-3 py-2 bg-white text-slate-800 text-sm font-semibold rounded-lg hover:bg-orange-50 transition-colors">
                  <Plus className="w-4 h-4" /> Insérer tous ({fdAll.length})
                </button>
                <button type="button" onClick={openFDPicker} data-testid="fd-pick-btn" className="flex items-center gap-1.5 px-3 py-2 bg-white/20 text-white text-sm font-medium rounded-lg hover:bg-white/30 transition-colors">
                  Choisir…
                </button>
              </div>
            )}
            {!isLocked && showFD && fdSelection && (
              <div className="flex items-center gap-2 shrink-0">
                <button type="button" onClick={openFDPicker} data-testid="fd-edit-selection-btn" className="px-3 py-2 bg-white/20 text-white text-sm font-medium rounded-lg hover:bg-white/30 transition-colors">Modifier la sélection</button>
                <button type="button" onClick={handleInsertAllFD} data-testid="fd-show-all-btn" className="px-3 py-2 bg-white/20 text-white text-sm font-medium rounded-lg hover:bg-white/30 transition-colors">Tout afficher</button>
              </div>
            )}
            <label className="flex items-center gap-2 cursor-pointer select-none shrink-0" title="Afficher ou masquer la section Fournisseurs directs sur ce devis et son PDF">
              <span className="text-sm font-medium">{showFD ? 'Inclus dans le PDF' : 'Exclus du PDF'}</span>
              <button
                type="button"
                role="switch"
                aria-checked={showFD}
                disabled={isLocked}
                onClick={handleToggleFD}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-white/60 disabled:opacity-50 ${showFD ? 'bg-white/90' : 'bg-white/30'}`}
                data-testid="fd-toggle"
              >
                <span className={`inline-block h-5 w-5 transform rounded-full shadow transition-transform ${showFD ? 'translate-x-5 bg-orange-500' : 'translate-x-0.5 bg-white'}`} />
              </button>
            </label>
            {!isLocked && showFD && (
              <button
                onClick={handleResyncFournisseurs}
                disabled={resyncingFD}
                data-testid="resync-fournisseurs-btn"
                className="flex items-center gap-2 px-3 py-2 bg-white/20 text-white text-sm font-medium rounded-lg hover:bg-white/30 disabled:opacity-50 transition-colors"
              >
                <RefreshCw className={`w-4 h-4 ${resyncingFD ? 'animate-spin' : ''}`} />
                Resync Base
              </button>
            )}
          </div>
        </div>
        {fdPickerOpen && !isLocked && (
          <div className="p-4 bg-orange-50 border-b border-orange-200" data-testid="fd-picker">
            <div className="flex items-center justify-between mb-3">
              <p className="text-sm font-semibold text-slate-800">Choisir les fournisseurs directs à insérer sur ce devis</p>
              <div className="flex gap-2 text-xs">
                <button type="button" onClick={() => setFdPickerIds(new Set(fdAll.map(fd => fd.id)))} className="text-orange-700 hover:underline">Tout cocher</button>
                <button type="button" onClick={() => setFdPickerIds(new Set())} className="text-slate-500 hover:underline">Tout décocher</button>
              </div>
            </div>
            <div className="grid sm:grid-cols-3 gap-4">
              {['intervenants', 'fournitures', 'divers'].map((categorie) => (
                <div key={categorie}>
                  <p className="text-xs font-bold uppercase text-slate-500 mb-1">{categorie === 'intervenants' ? 'Intervenants mandatés' : categorie === 'fournitures' ? 'Fourniture matériaux' : 'Divers organismes'}</p>
                  {fdAll.filter(fd => fd.categorie === categorie).map(fd => (
                    <label key={fd.id} className="flex items-center gap-2 py-0.5 text-sm text-slate-700 cursor-pointer">
                      <input type="checkbox" checked={fdPickerIds.has(fd.id)} onChange={() => toggleFDPickerId(fd.id)} className="rounded border-slate-300" data-testid={`fd-pick-${fd.id}`} />
                      <span className="truncate">{fd.designation}</span>
                      {fd.montant_ht > 0 && <span className="ml-auto font-mono text-xs text-slate-500">{formatMoney(fd.montant_ht)}</span>}
                    </label>
                  ))}
                </div>
              ))}
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button type="button" onClick={() => setFdPickerOpen(false)} className="px-3 py-2 text-sm text-slate-600 hover:bg-slate-100 rounded-lg">Annuler</button>
              <button type="button" onClick={handleConfirmFDPicker} data-testid="fd-picker-confirm-btn" className="px-4 py-2 bg-orange-500 text-white text-sm font-semibold rounded-lg hover:bg-orange-600">
                Insérer {fdPickerIds.size} fournisseur(s)
              </button>
            </div>
          </div>
        )}
        {showFD && <div className="p-4">
          {/* Bulk delete bar */}
          {selectedFDs.size > 0 && !isLocked && (
            <div className="flex items-center gap-3 mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
              <span className="text-sm font-medium text-red-700">{selectedFDs.size} sélectionné(s)</span>
              <button
                onClick={handleBulkDeleteFD}
                data-testid="bulk-delete-fd-btn"
                className="flex items-center gap-1 px-3 py-1.5 bg-red-600 text-white text-sm font-medium rounded hover:bg-red-700"
              >
                <Trash2 className="w-3.5 h-3.5" />
                Supprimer la sélection
              </button>
              <button
                onClick={() => setSelectedFDs(new Set())}
                className="text-sm text-slate-500 hover:text-slate-700 ml-auto"
              >
                Désélectionner tout
              </button>
            </div>
          )}

          {['intervenants', 'fournitures', 'divers'].map((categorie) => {
            const label = categorie === 'intervenants' ? 'Lots des intervenants mandatés' : categorie === 'fournitures' ? 'Fourniture matériaux' : 'Divers organismes';
            const items = fdVisible.filter(fd => fd.categorie === categorie);
            const allChecked = items.length > 0 && items.every(fd => selectedFDs.has(fd.id));
            return (
              <div key={categorie} className="mb-4">
                <p className="text-sm font-bold text-slate-700 mb-2">{label}</p>
                <table className="w-full">
                  <thead className="bg-slate-50">
                    <tr>
                      {!isLocked && (
                        <th className="px-2 py-2 w-8">
                          <input type="checkbox" checked={allChecked} onChange={() => toggleAllFDsInCategory(categorie)} className="rounded border-slate-300" data-testid={`fd-check-all-${categorie}`} />
                        </th>
                      )}
                      <th className="px-3 py-2 text-left text-xs font-bold uppercase text-slate-500">Désignation</th>
                      <th className="px-3 py-2 text-left text-xs font-bold uppercase text-slate-500 w-32">Fournisseur</th>
                      <th className="px-3 py-2 text-left text-xs font-bold uppercase text-slate-500 w-28">Payeur</th>
                      <th className="px-3 py-2 text-right text-xs font-bold uppercase text-slate-500 w-32">Montant HT</th>
                      {!isLocked && <th className="px-3 py-2 w-10"></th>}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {items.map((fd) => (
                      <tr key={fd.id} className={`hover:bg-slate-50 ${selectedFDs.has(fd.id) ? 'bg-red-50' : ''}`}>
                        {!isLocked && (
                          <td className="px-2 py-1">
                            <input type="checkbox" checked={selectedFDs.has(fd.id)} onChange={() => toggleFDSelection(fd.id)} className="rounded border-slate-300" data-testid={`fd-check-${fd.id}`} />
                          </td>
                        )}
                        <td className="px-3 py-1">
                          <input type="text" defaultValue={fd.designation || ''} disabled={isLocked} onBlur={(e) => handleUpdateFDField(fd, 'designation', e.target.value)} className={`w-full h-8 px-2 text-sm border border-slate-200 rounded focus:border-orange-500 focus:outline-none ${isLocked ? 'bg-slate-100 cursor-not-allowed' : ''}`} />
                        </td>
                        <td className="px-3 py-1">
                          <input type="text" defaultValue={fd.fournisseur || ''} placeholder="-" disabled={isLocked} onBlur={(e) => handleUpdateFDField(fd, 'fournisseur', e.target.value)} className={`w-full h-8 px-2 text-sm border border-slate-200 rounded focus:border-orange-500 focus:outline-none ${isLocked ? 'bg-slate-100 cursor-not-allowed' : ''}`} />
                        </td>
                        <td className="px-3 py-1">
                          <input type="text" defaultValue={fd.payeur || 'CLIENT'} disabled={isLocked} onBlur={(e) => handleUpdateFDField(fd, 'payeur', e.target.value)} className={`w-full h-8 px-2 text-sm border border-slate-200 rounded focus:border-orange-500 focus:outline-none ${isLocked ? 'bg-slate-100 cursor-not-allowed' : ''}`} />
                        </td>
                        <td className="px-3 py-1">
                          <input type="number" defaultValue={fd.montant_ht || 0} min="0" step="0.01" disabled={isLocked} onBlur={(e) => handleUpdateFDField(fd, 'montant_ht', e.target.value)} className={`w-full h-8 px-2 text-sm text-right font-mono border border-slate-200 rounded focus:border-orange-500 focus:outline-none ${isLocked ? 'bg-slate-100 cursor-not-allowed' : ''}`} />
                        </td>
                        {!isLocked && (
                          <td className="px-3 py-1">
                            <button onClick={() => handleDeleteFournisseurDirect(fd.id)} className="p-1 text-red-500 hover:bg-red-50 rounded"><Trash2 className="w-4 h-4" /></button>
                          </td>
                        )}
                      </tr>
                    ))}
                    {items.length === 0 && (
                      <tr><td colSpan={isLocked ? "5" : "7"} className="px-3 py-2 text-center text-sm text-slate-400">Aucun</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            );
          })}

          {/* Total */}
          <div className="bg-orange-50 border-t-2 border-orange-200 px-4 py-3 flex justify-between">
            <span className="text-sm font-bold text-slate-900">TOTAL FOURNISSEURS DIRECTS</span>
            <span className="text-sm font-bold text-slate-900 font-mono">{formatMoney(devis.total_ht_fournisseurs_directs)}</span>
          </div>

          {/* Ajouter fournisseur direct */}
          {!isLocked && (
            <div className="border-t border-slate-200 pt-4 mt-4">
              <p className="text-sm font-medium text-slate-600 mb-2">Ajouter un fournisseur direct</p>
              <div className="flex gap-2 flex-wrap">
                <select
                  value={newFD.categorie}
                  onChange={(e) => setNewFD({...newFD, categorie: e.target.value})}
                  className="h-9 px-3 text-sm border border-slate-300 rounded-md"
                >
                  <option value="intervenants">Intervenant mandaté</option>
                  <option value="fournitures">Fourniture matériaux</option>
                  <option value="divers">Divers organisme</option>
                </select>
                <input
                  type="text"
                  placeholder="Désignation"
                  value={newFD.designation}
                  onChange={(e) => setNewFD({...newFD, designation: e.target.value})}
                  className="flex-1 min-w-[200px] h-9 px-3 text-sm border border-slate-300 rounded-md"
                />
                <input
                  type="text"
                  placeholder="Payeur (CLIENT, CENTRE CO...)"
                  value={newFD.payeur}
                  onChange={(e) => setNewFD({...newFD, payeur: e.target.value})}
                  className="w-36 h-9 px-3 text-sm border border-slate-300 rounded-md"
                />
                <input
                  type="number"
                  placeholder="Montant HT"
                  value={newFD.montant_ht}
                  onChange={(e) => setNewFD({...newFD, montant_ht: e.target.value})}
                  className="w-28 h-9 px-3 text-sm border border-slate-300 rounded-md text-right"
                />
                <button
                  onClick={handleAddFournisseurDirect}
                  className="h-9 px-4 bg-orange-500 text-white rounded-md text-sm font-medium hover:bg-orange-600 flex items-center"
                >
                  <Plus className="w-4 h-4 mr-1" />
                  Ajouter
                </button>
              </div>
            </div>
          )}
        </div>}
      </div>

      {/* Récapitulatif Général */}
      <div className="bg-white rounded-lg border-2 border-orange-500 shadow-sm mb-6 overflow-hidden">
        <div className="bg-orange-500 text-white px-6 py-4">
          <h2 className="text-lg font-semibold">BUDGET TOTAL CLIENT</h2>
        </div>
        <div className="p-6">
          <div className="space-y-3">
            <div className="flex justify-between text-sm">
              <span className="text-slate-600">Total MAAG HT</span>
              <span className="font-mono font-medium">{formatMoney(devis.total_ht_maag || 0)}</span>
            </div>
            {showFD && (
              <div className="flex justify-between text-sm">
                <span className="text-slate-600">Total Fournisseurs Directs HT</span>
                <span className="font-mono font-medium">{formatMoney(devis.total_ht_fournisseurs_directs || 0)}</span>
              </div>
            )}
            <div className="border-t border-slate-200 pt-3 flex justify-between text-sm">
              <span className="font-semibold text-slate-700">BUDGET TOTAL HT</span>
              <span className="font-mono font-semibold" data-testid="budget-total-ht">{formatMoney((devis.total_ht_maag || 0) + (showFD ? (devis.total_ht_fournisseurs_directs || 0) : 0))}</span>
            </div>
            <div className="border-t-2 border-orange-500 pt-3 flex justify-between">
              <span className="text-lg font-bold text-slate-900">BUDGET TOTAL TTC</span>
              <span className="text-lg font-bold text-orange-600 font-mono" data-testid="budget-total-ttc">{formatMoney(((devis.total_ht_maag || 0) + (showFD ? (devis.total_ht_fournisseurs_directs || 0) : 0)) * 1.20)}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Détail des lots */}
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-slate-900">DÉTAIL DES LOTS MAAG</h2>
          {!isLocked && selectedPostes.size > 0 && (
            <button
              onClick={handleBulkDelete}
              disabled={isDeleting}
              className="flex items-center px-3 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 disabled:opacity-50"
            >
              {isDeleting ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <Trash2 className="w-4 h-4 mr-2" />
              )}
              Supprimer ({selectedPostes.size})
            </button>
          )}
        </div>
        
        {/* Selection info */}
        {!isLocked && selectedPostes.size > 0 && (
          <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-2 flex items-center justify-between">
            <span className="text-sm text-amber-800">
              <Check className="w-4 h-4 inline mr-2" />
              {selectedPostes.size} poste(s) sélectionné(s)
            </span>
            <button 
              onClick={() => setSelectedPostes(new Set())}
              className="text-sm text-amber-600 hover:text-amber-800"
            >
              Tout désélectionner
            </button>
          </div>
        )}
        
        {devis.lots.map((lot) => (
          <div 
            key={lot.id} 
            className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden"
            data-testid={`lot-${lot.id}`}
          >
            {/* Lot header */}
            <div className="flex items-center justify-between px-6 py-4 bg-slate-50 border-b border-slate-200">
              <button
                onClick={() => toggleLot(lot.id)}
                className="flex items-center flex-1 hover:bg-slate-100 -mx-2 px-2 py-1 rounded transition-colors"
              >
                {expandedLots[lot.id] ? (
                  <ChevronDown className="w-5 h-5 text-slate-400 mr-2" />
                ) : (
                  <ChevronRight className="w-5 h-5 text-slate-400 mr-2" />
                )}
                {editingLotId === lot.id ? (
                  <span className="flex items-center gap-2 flex-1" onClick={(e) => e.stopPropagation()}>
                    <span className="font-semibold text-slate-900">{lot.id}.</span>
                    <input
                      autoFocus
                      value={editingLotNom}
                      onChange={(e) => setEditingLotNom(e.target.value)}
                      onKeyDown={(e) => { if (e.key === 'Enter') handleRenameLot(); if (e.key === 'Escape') setEditingLotId(null); }}
                      className="flex-1 max-w-md h-8 px-2 rounded-md border border-indigo-400 bg-white text-sm font-semibold text-slate-900 uppercase focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      data-testid={`lot-rename-input-${lot.id}`}
                    />
                    <button onClick={handleRenameLot} className="p-1.5 text-green-600 hover:bg-green-50 rounded" title="Valider" data-testid={`lot-rename-save-${lot.id}`}><Check className="w-4 h-4" /></button>
                    <button onClick={() => setEditingLotId(null)} className="p-1.5 text-slate-400 hover:bg-slate-100 rounded" title="Annuler" data-testid={`lot-rename-cancel-${lot.id}`}><X className="w-4 h-4" /></button>
                  </span>
                ) : (
                  <>
                    <span className="font-semibold text-slate-900" data-testid={`lot-title-${lot.id}`}>
                      {lot.id}. {lot.nom}
                    </span>
                    <span className="ml-3 text-sm text-slate-500">
                      ({lot.postes.length} poste{lot.postes.length !== 1 ? 's' : ''})
                    </span>
                  </>
                )}
              </button>
              <div className="flex items-center gap-3">
                <span className="font-mono font-semibold text-slate-900">
                  {formatMoney(lot.total_ht)}
                </span>
                {!isLocked && editingLotId !== lot.id && (
                  <button
                    onClick={(e) => { e.stopPropagation(); startRenameLot(lot); }}
                    className="p-2 text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors"
                    title="Renommer ce lot (uniquement pour ce devis)"
                    data-testid={`lot-rename-btn-${lot.id}`}
                  >
                    <Edit3 className="w-4 h-4" />
                  </button>
                )}
                {!isLocked && (
                  <button
                    onClick={(e) => { e.stopPropagation(); openNewPosteModal(lot.id); }}
                    className="inline-flex items-center gap-1 px-2 py-1 bg-indigo-600 text-white rounded-lg text-xs font-medium hover:bg-indigo-700 transition-colors"
                    title="Ajouter une prestation à ce lot"
                    data-testid={`add-poste-lot-${lot.id}`}
                  >
                    <Plus className="w-3.5 h-3.5" /> Ajouter
                  </button>
                )}
                {lot.postes.length > 0 && !isLocked && (
                  <button
                    onClick={(e) => { e.stopPropagation(); handleClearLot(lot.id, lot.nom); }}
                    disabled={isDeleting}
                    className="p-2 text-orange-500 hover:bg-orange-50 rounded-lg transition-colors"
                    title="Vider ce lot (supprime les postes, garde le lot)"
                    data-testid={`lot-clear-btn-${lot.id}`}
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
                {!isLocked && (
                  <button
                    onClick={(e) => { e.stopPropagation(); handleDeleteLot(lot); }}
                    disabled={isDeleting}
                    className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    title="Supprimer ce lot du devis (et du PDF)"
                    data-testid={`lot-delete-btn-${lot.id}`}
                  >
                    <X className="w-4 h-4" />
                  </button>
                )}
              </div>
            </div>

            {/* Lot content */}
            {expandedLots[lot.id] && (
              <div className="p-4">
                {/* Postes table */}
                {lot.postes.length > 0 && (
                  <table className="w-full mb-4">
                    <thead className="bg-slate-50">
                      <tr>
                        <th className="px-2 py-2 w-10">
                          <input
                            type="checkbox"
                            checked={lot.postes.length > 0 && lot.postes.every(p => selectedPostes.has(p.id))}
                            onChange={() => selectAllInLot(lot)}
                            className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </th>
                        <th className="px-3 py-2 text-left text-xs font-bold uppercase text-slate-500">Description</th>
                        <th className="px-3 py-2 text-center text-xs font-bold uppercase text-slate-500 w-20">Unité</th>
                        <th className="px-3 py-2 text-right text-xs font-bold uppercase text-slate-500 w-24">Qté</th>
                        <th className="px-3 py-2 text-right text-xs font-bold uppercase text-slate-500 w-32">P.U. HT</th>
                        <th className="px-3 py-2 text-right text-xs font-bold uppercase text-slate-500 w-32">Total HT</th>
                        <th className="px-3 py-2 w-20"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100">
                      {/* Group postes by sous-lot > sous-sous-lot */}
                      {(() => {
                        // Build groups
                        const groups = [];
                        const displayedSousLots = new Set();
                        const displayedSousSousLots = new Set(); // keys = `${sousLotNom||''}::${sousSousLotNom}`
                        const displayedGroupes = new Set(); // keys = `${sousLotNom||''}::${sousSousLotNom||''}::${groupeNom}`
                        
                        // Sort postes: sous_lot_nom, then sous_sous_lot_nom, then groupe_nom, then display_order, then description
                        const sortedPostes = [...lot.postes].sort((a, b) => {
                          const aName = a.sous_lot_nom || 'zzz';
                          const bName = b.sous_lot_nom || 'zzz';
                          if (aName !== bName) return aName.localeCompare(bName);
                          const aSub = a.sous_sous_lot_nom || 'zzz';
                          const bSub = b.sous_sous_lot_nom || 'zzz';
                          if (aSub !== bSub) return aSub.localeCompare(bSub);
                          const aG = a.groupe_nom || '';
                          const bG = b.groupe_nom || '';
                          if (aG !== bG) return aG.localeCompare(bG);
                          const aOrd = a.display_order ?? 10000000;
                          const bOrd = b.display_order ?? 10000000;
                          if (aOrd !== bOrd) return aOrd - bOrd;
                          return (a.description || '').localeCompare(b.description || '');
                        });
                        
                        sortedPostes.forEach((poste, idx) => {
                          const sousLotNom = poste.sous_lot_nom;
                          const sousSousLotNom = poste.sous_sous_lot_nom;
                          
                          // Add sous-lot header only once per sous-lot
                          if (sousLotNom && !displayedSousLots.has(sousLotNom)) {
                            displayedSousLots.add(sousLotNom);
                            const sousLotPostes = sortedPostes.filter(p => p.sous_lot_nom === sousLotNom);
                            const sousLotTotal = sousLotPostes.reduce((sum, p) => sum + (p.quantite * p.prix_unitaire), 0);
                            
                            groups.push(
                              <tr
                                key={`header-${sousLotNom}`}
                                className={`bg-indigo-50/70 border-t-2 border-indigo-200 ${dragOverKey === `header-${sousLotNom}` ? 'ring-2 ring-indigo-400' : ''}`}
                                onDragOver={onDragOverTarget(`header-${sousLotNom}`)}
                                onDrop={onDropOnHeader(sousLotNom, null)}
                              >
                                <td colSpan={7} className="px-3 py-2">
                                  <div className="flex items-center gap-2">
                                    <input
                                      type="text"
                                      defaultValue=""
                                      placeholder="N°"
                                      className="w-10 h-6 px-1 text-center text-xs font-bold border border-indigo-300 rounded bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                      onBlur={async (e) => {
                                        const newOrdre = e.target.value.trim();
                                        if (newOrdre) {
                                          // Update all postes with this sous_lot_nom to have the new prefix
                                          const newName = `${newOrdre}. ${sousLotNom.replace(/^\d+\.\s*/, '')}`;
                                          for (const p of sousLotPostes) {
                                            try {
                                              await updatePoste(p.id, { sous_lot_nom: newName });
                                            } catch (err) { console.error(err); }
                                          }
                                          toast.success('Ordre mis à jour');
                                          loadData();
                                        }
                                      }}
                                      onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                                    />
                                    <span className="text-sm font-semibold text-indigo-700 uppercase tracking-wide">
                                      {sousLotNom}
                                    </span>
                                    <span className="text-xs text-indigo-500">
                                      ({sousLotPostes.length} poste{sousLotPostes.length > 1 ? 's' : ''})
                                    </span>
                                    {!isLocked && (
                                      <button
                                        onClick={(e) => { e.stopPropagation(); openNewPosteModal(lot.id, sousLotNom); }}
                                        className="ml-2 inline-flex items-center gap-1 px-2 py-0.5 bg-white border border-indigo-300 text-indigo-700 rounded text-xs font-medium hover:bg-indigo-100"
                                        title="Ajouter une prestation dans ce sous-lot"
                                        data-testid={`add-poste-in-${sousLotNom}`}
                                      >
                                        <Plus className="w-3 h-3" /> Ajouter
                                      </button>
                                    )}
                                    <span className="ml-auto font-mono text-sm font-semibold text-indigo-700">
                                      {formatMoney(sousLotTotal)}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                          
                          // Add sous-sous-lot header only once per (sousLot, sousSousLot) pair
                          if (sousSousLotNom) {
                            const ssKey = `${sousLotNom || ''}::${sousSousLotNom}`;
                            if (!displayedSousSousLots.has(ssKey)) {
                              displayedSousSousLots.add(ssKey);
                              const ssPostes = sortedPostes.filter(p => (p.sous_lot_nom || '') === (sousLotNom || '') && p.sous_sous_lot_nom === sousSousLotNom);
                              const ssTotal = ssPostes.reduce((sum, p) => sum + (p.quantite * p.prix_unitaire), 0);
                              groups.push(
                                <tr
                                  key={`subheader-${sousLotNom || ''}-${sousSousLotNom}`}
                                  className={`bg-slate-50 ${dragOverKey === `subheader-${ssKey}` ? 'ring-2 ring-slate-400' : ''}`}
                                  onDragOver={onDragOverTarget(`subheader-${ssKey}`)}
                                  onDrop={onDropOnHeader(sousLotNom, sousSousLotNom)}
                                >
                                  <td colSpan={7} className="px-3 py-1.5">
                                    <div className="flex items-center gap-2 pl-6">
                                      <span className="text-xs font-bold text-slate-700 uppercase tracking-wide">
                                        └ {sousSousLotNom}
                                      </span>
                                      <span className="text-[10px] text-slate-400">
                                        ({ssPostes.length} poste{ssPostes.length > 1 ? 's' : ''})
                                      </span>
                                      {!isLocked && (
                                        <button
                                          onClick={(e) => { e.stopPropagation(); openNewPosteModal(lot.id, sousLotNom || '', sousSousLotNom); }}
                                          className="ml-2 inline-flex items-center gap-1 px-2 py-0.5 bg-white border border-slate-300 text-slate-700 rounded text-[11px] font-medium hover:bg-slate-100"
                                          title="Ajouter une prestation dans ce sous-sous-lot"
                                          data-testid={`add-poste-in-sub-${sousSousLotNom}`}
                                        >
                                          <Plus className="w-3 h-3" /> Ajouter
                                        </button>
                                      )}
                                      <span className="ml-auto font-mono text-xs font-semibold text-slate-700">
                                        {formatMoney(ssTotal)}
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          }
                          
                          // Add groupe header only once per (sousLot, sousSousLot, groupe) tuple
                          const groupeNom = poste.groupe_nom;
                          if (groupeNom) {
                            const gKey = `${sousLotNom || ''}::${sousSousLotNom || ''}::${groupeNom}`;
                            if (!displayedGroupes.has(gKey)) {
                              displayedGroupes.add(gKey);
                              groups.push(
                                <tr
                                  key={`group-${gKey}`}
                                  className="border-t border-slate-200"
                                >
                                  <td colSpan={7} className="px-3 pt-3 pb-1">
                                    <div className="flex items-center gap-2 pl-10">
                                      <span className="text-base font-bold text-slate-800" style={{ color: '#1E293B' }}>
                                        {groupeNom}
                                      </span>
                                      {!isLocked && (
                                        <button
                                          onClick={(e) => { e.stopPropagation(); openNewPosteModal(lot.id, sousLotNom || '', sousSousLotNom || '', groupeNom); }}
                                          className="ml-2 inline-flex items-center gap-1 px-2 py-0.5 bg-white border border-slate-300 text-slate-600 rounded text-[11px] font-medium hover:bg-slate-50"
                                          title="Ajouter une prestation dans ce groupe"
                                          data-testid={`add-poste-in-groupe-${groupeNom}`}
                                        >
                                          <Plus className="w-3 h-3" /> Ajouter
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            }
                          }
                          
                          // Add poste row
                          groups.push(
                            <tr
                              key={poste.id}
                              className={`hover:bg-slate-50/50 ${selectedPostes.has(poste.id) ? 'bg-indigo-50' : ''} ${draggingPosteId === poste.id ? 'opacity-40' : ''} ${dragOverKey === `poste-${poste.id}` ? 'border-t-2 border-indigo-500' : ''}`}
                              draggable={!editingPoste && !isLocked}
                              onDragStart={onDragStartPoste(poste.id)}
                              onDragEnd={onDragEnd}
                              onDragOver={onDragOverTarget(`poste-${poste.id}`)}
                              onDrop={onDropOnPoste(poste)}
                              data-testid={`poste-${poste.id}`}
                            >
                              {editingPoste?.id === poste.id ? (
                            <>
                              <td className="px-2 py-2"></td>
                              <td className="px-3 py-2">
                                <textarea
                                  value={editingPoste.description}
                                  onChange={(e) => setEditingPoste({...editingPoste, description: e.target.value})}
                                  className="w-full px-2 py-2 text-sm border border-slate-300 rounded resize-y leading-snug"
                                  rows={4}
                                  style={{ minHeight: '110px' }}
                                  spellCheck="true"
                                  lang="fr"
                                  autoFocus
                                />
                                <div className="grid grid-cols-2 gap-1 mt-1">
                                  <div className="text-xs">
                                    <LocalisationCombobox
                                      value={editingPoste.localisation || ''}
                                      onChange={(v) => setEditingPoste({...editingPoste, localisation: v})}
                                      options={localisationsList}
                                      placeholder="Localisation"
                                      testId={`edit-loc-${poste.id}`}
                                    />
                                  </div>
                                  <textarea
                                    value={editingPoste.commentaire || ''}
                                    onChange={(e) => setEditingPoste({...editingPoste, commentaire: e.target.value})}
                                    placeholder="Commentaire (optionnel)"
                                    className="px-2 py-1.5 text-xs italic text-blue-700 border border-blue-200 bg-blue-50 rounded resize-y"
                                    rows={2}
                                    style={{ minHeight: '56px' }}
                                    spellCheck="true"
                                    lang="fr"
                                    data-testid={`edit-com-${poste.id}`}
                                  />
                                </div>
                              </td>
                              <td className="px-3 py-2">
                                <select
                                  value={editingPoste.unite}
                                  onChange={(e) => setEditingPoste({...editingPoste, unite: e.target.value})}
                                  className="w-full h-8 px-2 text-sm border border-slate-300 rounded"
                                >
                                  <option value="U">U</option>
                                  <option value="m²">m²</option>
                                  <option value="ml">ml</option>
                                  <option value="Ft">Ft</option>
                                  <option value="Ens">Ens</option>
                                  <option value="Benne">Benne</option>
                                </select>
                              </td>
                              <td className="px-3 py-2">
                                <input
                                  type="number"
                                  step="0.01"
                                  value={editingPoste.quantite}
                                  onChange={(e) => setEditingPoste({...editingPoste, quantite: e.target.value})}
                                  className="w-full h-8 px-2 text-sm border border-slate-300 rounded text-right"
                                />
                              </td>
                              <td className="px-3 py-2">
                                <input
                                  type="number"
                                  step="0.01"
                                  value={editingPoste.prix_unitaire}
                                  onChange={(e) => setEditingPoste({...editingPoste, prix_unitaire: e.target.value})}
                                  className="w-full h-8 px-2 text-sm border border-slate-300 rounded text-right"
                                />
                              </td>
                              <td className="px-3 py-2 text-right font-mono text-sm">
                                {formatMoney((parseFloat(editingPoste.quantite) || 0) * (parseFloat(editingPoste.prix_unitaire) || 0))}
                              </td>
                              <td className="px-3 py-2">
                                <div className="flex gap-1">
                                  <button
                                    onClick={() => handleUpdatePoste(poste.id)}
                                    className="p-1 text-green-600 hover:bg-green-50 rounded"
                                    data-testid={`save-poste-${poste.id}`}
                                  >
                                    <Save className="w-4 h-4" />
                                  </button>
                                  <button
                                    onClick={() => setEditingPoste(null)}
                                    className="p-1 text-slate-400 hover:bg-slate-100 rounded"
                                  >
                                    ×
                                  </button>
                                </div>
                              </td>
                            </>
                          ) : (
                            <>
                              <td className="px-2 py-2">
                                {!isLocked && (
                                  <input
                                    type="checkbox"
                                    checked={selectedPostes.has(poste.id)}
                                    onChange={() => toggleSelectPoste(poste.id)}
                                    className="w-4 h-4 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
                                  />
                                )}
                              </td>
                              <td 
                                className={`px-3 py-2 text-sm text-slate-700 ${!isLocked ? 'cursor-pointer hover:text-orange-500' : ''}`}
                                onClick={() => !isLocked && setEditingPoste({...poste})}
                              >
                                <div className="flex items-start gap-2">
                                  {!isLocked && (
                                    <GripVertical
                                      className="w-4 h-4 text-slate-300 mt-0.5 cursor-grab active:cursor-grabbing shrink-0"
                                      onClick={(e) => e.stopPropagation()}
                                      title="Glisser pour déplacer"
                                    />
                                  )}
                                  <div className="flex-1">
                                    {(() => {
                                      const desc = poste.description || '';
                                      const sepIdx = desc.indexOf(' - ');
                                      if (sepIdx > 0 && sepIdx < 200) {
                                        return (
                                          <>
                                            <span className="font-bold uppercase">{desc.substring(0, sepIdx)}</span>
                                            <span> - {desc.substring(sepIdx + 3)}</span>
                                          </>
                                        );
                                      }
                                      // No separator — consider first line as title
                                      const lines = desc.split('\n');
                                      if (lines.length > 1) {
                                        return (
                                          <>
                                            <div className="font-bold uppercase">{lines[0]}</div>
                                            <div>{lines.slice(1).join('\n')}</div>
                                          </>
                                        );
                                      }
                                      return <span className="font-bold uppercase">{desc}</span>;
                                    })()}
                                    {(poste.localisation || poste.commentaire) && (
                                      <div className="mt-1 space-y-0.5">
                                        {poste.localisation && (
                                          <div className="text-xs italic text-emerald-700" data-testid={`poste-loc-${poste.id}`}>
                                            Loc. : {poste.localisation}
                                          </div>
                                        )}
                                        {poste.commentaire && (
                                          <div className="text-xs italic text-emerald-700" data-testid={`poste-com-${poste.id}`}>
                                            {poste.commentaire}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </td>
                              <td className="px-3 py-2 text-sm text-slate-500 text-center">{poste.unite}</td>
                              <td className="px-3 py-2 text-sm text-slate-700 text-right font-mono">{poste.quantite}</td>
                              <td className="px-3 py-2 text-sm text-slate-700 text-right font-mono">{formatMoney(poste.prix_unitaire)}</td>
                              <td className="px-3 py-2 text-sm text-slate-900 text-right font-mono font-medium">{formatMoney(poste.prix_total)}</td>
                              <td className="px-3 py-2">
                                {!isLocked && (
                                  <div className="flex gap-1 flex-wrap">
                                    <button
                                      onClick={() => handleMovePoste(poste.id, 'up')}
                                      className="p-1 text-slate-500 hover:bg-slate-100 rounded"
                                      title="Monter"
                                      data-testid={`move-up-${poste.id}`}
                                    >
                                      <ChevronUp className="w-4 h-4" />
                                    </button>
                                    <button
                                      onClick={() => handleMovePoste(poste.id, 'down')}
                                      className="p-1 text-slate-500 hover:bg-slate-100 rounded"
                                      title="Descendre"
                                      data-testid={`move-down-${poste.id}`}
                                    >
                                      <ChevronDown className="w-4 h-4" />
                                    </button>
                                    <button
                                      onClick={() => setAiRewriteTarget({ posteId: poste.id, lotNom: lot.nom, text: poste.description })}
                                      className="p-1 text-violet-500 hover:bg-violet-50 rounded"
                                      title="Réécrire avec l'IA"
                                      data-testid={`ai-rewrite-${poste.id}`}
                                    >
                                      <Sparkles className="w-4 h-4" />
                                    </button>
                                    <button
                                      onClick={() => openEditPosteFull(poste, lot)}
                                      className="p-1 text-indigo-500 hover:bg-indigo-50 rounded"
                                      title="Modifier la prestation (interface complète + catalogue)"
                                      data-testid={`edit-full-${poste.id}`}
                                    >
                                      <Edit3 className="w-4 h-4" />
                                    </button>
                                    <button
                                      onClick={() => handleDuplicatePoste(poste)}
                                      className="p-1 text-green-500 hover:bg-green-50 rounded"
                                      title="Dupliquer la prestation"
                                    >
                                      <Copy className="w-4 h-4" />
                                    </button>
                                    <button
                                      onClick={() => {
                                        setEditingSousLot({ posteId: poste.id, lotId: lot.id, currentSousLot: poste.sous_lot_nom });
                                        setNewSousLotName(poste.sous_lot_nom || '');
                                      }}
                                      className="p-1 text-indigo-500 hover:bg-indigo-50 rounded"
                                      title="Modifier le sous-lot"
                                    >
                                      <FolderInput className="w-4 h-4" />
                                    </button>
                                    <button
                                      onClick={() => handleDeletePoste(poste.id)}
                                      className="p-1 text-red-500 hover:bg-red-50 rounded"
                                      title="Supprimer"
                                      data-testid={`delete-poste-${poste.id}`}
                                    >
                                      <Trash2 className="w-4 h-4" />
                                    </button>
                                  </div>
                                )}
                              </td>
                            </>
                          )}
                            </tr>
                          );
                        });
                        
                        return groups;
                      })()}
                    </tbody>
                  </table>
                )}

                {/* Add new poste button */}
                {!isLocked && (
                  <div className="border-t border-slate-200 pt-4 flex flex-wrap gap-2">
                    <button
                      onClick={() => openNewPosteModal(lot.id)}
                      className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors"
                      data-testid={`add-poste-btn-${lot.id}`}
                    >
                      <Plus className="w-4 h-4 mr-2" />
                      Ajouter une prestation
                    </button>
                    <button
                      onClick={() => openNewGroupementModal(lot.id)}
                      className="flex items-center px-4 py-2 bg-white text-indigo-700 border-2 border-indigo-300 rounded-lg text-sm font-medium hover:bg-indigo-50 transition-colors"
                      data-testid={`add-groupement-btn-${lot.id}`}
                      title="Créer un groupement de plusieurs prestations d'un coup"
                    >
                      <Package className="w-4 h-4 mr-2" />
                      Nouveau groupement
                    </button>
                    <button
                      onClick={() => openExistingGroupementsPicker(lot.id)}
                      className="flex items-center px-4 py-2 bg-white text-emerald-700 border-2 border-emerald-300 rounded-lg text-sm font-medium hover:bg-emerald-50 transition-colors"
                      data-testid={`pick-groupement-btn-${lot.id}`}
                      title="Insérer un groupement déjà sauvegardé"
                    >
                      <Package className="w-4 h-4 mr-2" />
                      Mes groupements
                    </button>
                    <button
                      onClick={() => openImportFromDevis(lot.id)}
                      className="flex items-center px-4 py-2 bg-white text-sky-700 border-2 border-sky-300 rounded-lg text-sm font-medium hover:bg-sky-50 transition-colors"
                      data-testid={`import-from-devis-btn-${lot.id}`}
                      title="Copier des lignes d'un autre devis"
                    >
                      <FileText className="w-4 h-4 mr-2" />
                      Importer d'un autre devis
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}

        {!isLocked && (
          <div className="flex flex-wrap items-center gap-3 pt-2" data-testid="lots-actions-bar">
            {showAddLot ? (
              <div className="flex items-center gap-2 flex-1 min-w-[280px]">
                <span className="text-sm font-semibold text-slate-500">{(Math.max(0, ...devis.lots.map(l => parseInt(l.id, 10) || 0)) + 1)}.</span>
                <input
                  autoFocus
                  value={newLotNom}
                  onChange={(e) => setNewLotNom(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') handleAddLot(); if (e.key === 'Escape') { setShowAddLot(false); setNewLotNom(''); } }}
                  placeholder="Nom du nouveau lot (ex : SIGNALÉTIQUE)"
                  className="flex-1 max-w-md h-9 px-3 rounded-lg border border-indigo-400 bg-white text-sm uppercase focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  data-testid="new-lot-input"
                />
                <button onClick={handleAddLot} className="inline-flex items-center gap-1 px-3 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700" data-testid="new-lot-save-btn">
                  <Check className="w-4 h-4" /> Créer
                </button>
                <button onClick={() => { setShowAddLot(false); setNewLotNom(''); }} className="px-3 py-2 text-sm text-slate-500 hover:text-slate-800" data-testid="new-lot-cancel-btn">Annuler</button>
              </div>
            ) : (
              <button
                onClick={() => setShowAddLot(true)}
                className="inline-flex items-center gap-2 px-4 py-2 border-2 border-dashed border-indigo-300 text-indigo-700 rounded-lg text-sm font-medium hover:bg-indigo-50 hover:border-indigo-500 transition-colors"
                data-testid="add-lot-btn"
              >
                <Plus className="w-4 h-4" /> Ajouter un lot
              </button>
            )}
            {hasCustomLots && (
              <button
                onClick={handleResetLots}
                className="inline-flex items-center gap-2 px-3 py-2 text-sm text-slate-500 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
                title="Revenir aux 18 lots MAAG standards"
                data-testid="reset-lots-btn"
              >
                <RefreshCw className="w-4 h-4" /> Réinitialiser les 18 lots standards
              </button>
            )}
          </div>
        )}
      </div>

      {/* Modal - Picker groupements existants */}
      {showGroupementsPicker && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-testid="groupements-picker-modal">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 max-h-[90vh] flex flex-col">
            <div className="flex items-center justify-between p-5 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2">
                  <Package className="w-5 h-5 text-emerald-600" /> Mes groupements
                </h2>
                <p className="text-xs text-slate-500">Cochez pour insérer plusieurs groupements d'un coup, ou cliquez le nom pour n'en insérer qu'un.</p>
              </div>
              <button onClick={() => { setShowGroupementsPicker(false); setSelectedGroupementIds(new Set()); }} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-5 space-y-2">
              {pickerLoading ? (
                <p className="text-sm text-slate-500 italic">Chargement…</p>
              ) : existingGroupements.length === 0 ? (
                <div className="text-center py-6">
                  <p className="text-sm text-slate-500 italic">Aucun groupement sauvegardé pour ce lot.</p>
                  <p className="text-xs text-slate-400 mt-2">Créez-en d'abord via "+ Nouveau groupement" ou depuis Base MAAG → "Initialiser groupements ADOPT".</p>
                </div>
              ) : (
                (() => {
                  const bySl = {};
                  existingGroupements.forEach(g => {
                    const k = g.sous_lot_nom || '(sans sous-lot)';
                    if (!bySl[k]) bySl[k] = [];
                    bySl[k].push(g);
                  });
                  return Object.keys(bySl).sort().map(sl => {
                    const items = bySl[sl];
                    const allSelected = items.every(g => selectedGroupementIds.has(g.id));
                    const someSelected = items.some(g => selectedGroupementIds.has(g.id));
                    return (
                      <div key={sl} className="mb-4">
                        <div className="flex items-center justify-between mb-2 px-1">
                          <h3 className="text-xs font-bold text-indigo-700 uppercase tracking-wide flex items-center gap-2">
                            <input
                              type="checkbox"
                              checked={allSelected}
                              ref={(el) => { if (el) el.indeterminate = someSelected && !allSelected; }}
                              onChange={() => toggleSousLotSelect(items)}
                              className="w-4 h-4 accent-emerald-600 cursor-pointer"
                              data-testid={`select-all-souslot-${sl}`}
                            />
                            {sl} <span className="text-slate-400 font-normal">· {items.length}</span>
                          </h3>
                          <button
                            onClick={() => toggleSousLotSelect(items)}
                            className="text-[10px] text-emerald-600 hover:text-emerald-700 font-medium"
                          >
                            {allSelected ? 'Tout décocher' : 'Tout cocher'}
                          </button>
                        </div>
                        <div className="space-y-1">
                          {items.map(tpl => {
                            const total = tpl.lignes.reduce((s, l) => s + (l.quantite * l.prix_unitaire), 0);
                            const isSelected = selectedGroupementIds.has(tpl.id);
                            return (
                              <div
                                key={tpl.id}
                                className={`flex items-center gap-2 p-3 bg-white border rounded-lg transition-colors ${isSelected ? 'border-emerald-400 bg-emerald-50' : 'border-slate-200 hover:border-emerald-300'}`}
                                data-testid={`groupement-template-${tpl.id}`}
                              >
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={() => toggleGroupementSelect(tpl.id)}
                                  className="w-4 h-4 accent-emerald-600 cursor-pointer flex-shrink-0"
                                  data-testid={`groupement-checkbox-${tpl.id}`}
                                />
                                <button
                                  onClick={() => insertGroupementFromTemplate(tpl)}
                                  className="flex-1 flex items-center justify-between text-left min-w-0"
                                  title="Insérer ce groupement seul"
                                >
                                  <div className="flex-1 min-w-0">
                                    <div className="text-sm font-semibold text-slate-800">{tpl.nom}</div>
                                    <div className="text-xs text-slate-500 truncate">{tpl.lignes.length} prestation{tpl.lignes.length > 1 ? 's' : ''}{tpl.sous_sous_lot_nom ? ` · ${tpl.sous_sous_lot_nom}` : ''}</div>
                                  </div>
                                  <div className="text-right flex-shrink-0 ml-3">
                                    <div className="text-sm font-mono font-semibold text-emerald-700">{formatMoney(total)}</div>
                                  </div>
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  });
                })()
              )}
            </div>
            {selectedGroupementIds.size > 0 && (
              <div className="p-4 border-t border-slate-200 bg-emerald-50 flex items-center justify-between gap-3">
                <div className="text-sm text-slate-700">
                  <span className="font-semibold">{selectedGroupementIds.size}</span> groupement{selectedGroupementIds.size > 1 ? 's' : ''} sélectionné{selectedGroupementIds.size > 1 ? 's' : ''}
                  {' '}· <span className="text-slate-500">
                    {existingGroupements.filter(g => selectedGroupementIds.has(g.id)).reduce((n, g) => n + (g.lignes?.length || 0), 0)} lignes au total
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => setSelectedGroupementIds(new Set())}
                    className="px-3 py-2 text-sm text-slate-600 hover:text-slate-900"
                  >
                    Vider
                  </button>
                  <button
                    onClick={insertSelectedGroupements}
                    className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-sm font-semibold"
                    data-testid="insert-selected-groupements-btn"
                  >
                    Insérer les {selectedGroupementIds.size} groupements
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal - Importer depuis un autre devis */}
      {showImportModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-testid="import-devis-modal" onClick={() => setShowImportModal(false)}>
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl mx-4 max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-5 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2">
                  <FileText className="w-5 h-5 text-sky-600" /> Importer d'un autre devis
                </h2>
                <p className="text-xs text-slate-500">
                  {!importSelectedDevisId
                    ? 'Sélectionnez le devis source.'
                    : `Cochez les lignes à copier dans ce devis (Lot ${importLotId}).`}
                </p>
              </div>
              <button onClick={() => setShowImportModal(false)} className="text-slate-400 hover:text-slate-600">
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-5">
              {importLoading ? (
                <div className="flex items-center justify-center py-12">
                  <div className="w-6 h-6 border-2 border-sky-500 border-t-transparent rounded-full animate-spin" />
                </div>
              ) : !importSelectedDevisId ? (
                // Step 1 : list devis
                importAvailableDevis.length === 0 ? (
                  <p className="text-sm text-slate-500 italic text-center py-6">Aucun autre devis disponible.</p>
                ) : (
                  <div className="space-y-1">
                    {importAvailableDevis.map(d => (
                      <button
                        key={d.id}
                        onClick={() => loadImportSourceDevis(d.id)}
                        className="w-full flex items-center justify-between p-3 bg-white border border-slate-200 rounded-lg hover:border-sky-400 hover:bg-sky-50 text-left"
                        data-testid={`import-source-devis-${d.id}`}
                      >
                        <div className="flex-1 min-w-0">
                          <div className="text-sm font-semibold text-slate-800 truncate">{d.projet_nom}</div>
                          <div className="text-xs text-slate-500 truncate">{d.objet} · v{d.version} · {d.postes_count} lignes</div>
                        </div>
                        <div className="text-right flex-shrink-0 ml-3">
                          <div className="text-sm font-mono font-semibold text-slate-700">{formatMoney(d.total_ht || 0)}</div>
                        </div>
                      </button>
                    ))}
                  </div>
                )
              ) : (
                // Step 2 : select postes from source devis, filtered by the lot we're importing into
                (() => {
                  if (!importSourceDevis || !importSourceDevis.postes) return <p className="text-sm text-slate-500 italic">Aucun poste.</p>;
                  const postes = importSourceDevis.postes.filter(p => String(p.lot_id) === String(importLotId));
                  if (postes.length === 0) {
                    return (
                      <div className="text-center py-6">
                        <p className="text-sm text-slate-500 italic">Ce devis ne contient aucune ligne pour le Lot {importLotId}.</p>
                        <button onClick={() => { setImportSelectedDevisId(null); setImportSourceDevis(null); }} className="mt-3 text-sm text-sky-600 hover:text-sky-700">← Choisir un autre devis</button>
                      </div>
                    );
                  }
                  // Group by sous_lot_nom → sous_sous_lot_nom
                  const bySl = {};
                  postes.forEach(p => {
                    const k1 = p.sous_lot_nom || '(sans sous-lot)';
                    const k2 = p.sous_sous_lot_nom || '';
                    if (!bySl[k1]) bySl[k1] = {};
                    if (!bySl[k1][k2]) bySl[k1][k2] = [];
                    bySl[k1][k2].push(p);
                  });
                  return (
                    <div className="space-y-4">
                      <button onClick={() => { setImportSelectedDevisId(null); setImportSourceDevis(null); setImportSelectedPosteIds(new Set()); }} className="text-sm text-sky-600 hover:text-sky-700">← Choisir un autre devis</button>
                      {Object.entries(bySl).sort(([a],[b]) => a.localeCompare(b)).map(([sl, byssl]) => {
                        const allSlIds = Object.values(byssl).flat().map(p => p.id);
                        const allSlSelected = allSlIds.every(id => importSelectedPosteIds.has(id));
                        return (
                          <div key={sl}>
                            <div className="flex items-center justify-between mb-2 px-1">
                              <h3 className="text-xs font-bold text-indigo-700 uppercase tracking-wide flex items-center gap-2">
                                <input
                                  type="checkbox"
                                  checked={allSlSelected}
                                  onChange={() => toggleImportGroup(allSlIds)}
                                  className="w-4 h-4 accent-sky-600 cursor-pointer"
                                />
                                {sl} <span className="text-slate-400 font-normal">· {allSlIds.length}</span>
                              </h3>
                              <button onClick={() => toggleImportGroup(allSlIds)} className="text-[10px] text-sky-600 hover:text-sky-700 font-medium">
                                {allSlSelected ? 'Tout décocher' : 'Tout cocher'}
                              </button>
                            </div>
                            {Object.entries(byssl).map(([ssl, items]) => (
                              <div key={ssl} className="mb-2">
                                {ssl && (
                                  <div className="flex items-center gap-2 mb-1 ml-2">
                                    <input
                                      type="checkbox"
                                      checked={items.every(p => importSelectedPosteIds.has(p.id))}
                                      onChange={() => toggleImportGroup(items.map(p => p.id))}
                                      className="w-3.5 h-3.5 accent-sky-600 cursor-pointer"
                                    />
                                    <span className="text-xs font-medium text-slate-600">└ {ssl}</span>
                                  </div>
                                )}
                                <div className="space-y-1 ml-4">
                                  {items.map(p => (
                                    <label
                                      key={p.id}
                                      className={`flex items-center gap-2 p-2 rounded border cursor-pointer ${importSelectedPosteIds.has(p.id) ? 'bg-sky-50 border-sky-300' : 'border-slate-200 hover:bg-slate-50'}`}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={importSelectedPosteIds.has(p.id)}
                                        onChange={() => toggleImportPoste(p.id)}
                                        className="w-4 h-4 accent-sky-600"
                                      />
                                      <div className="flex-1 min-w-0">
                                        <div className="text-sm text-slate-800 truncate">{p.description || '(vide)'}</div>
                                        {p.groupe_nom && <div className="text-[10px] text-slate-500">Groupe : {p.groupe_nom}</div>}
                                      </div>
                                      <div className="text-xs text-slate-500 whitespace-nowrap">
                                        {p.quantite} {p.unite} × {formatMoney(p.prix_unitaire || 0)}
                                      </div>
                                    </label>
                                  ))}
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  );
                })()
              )}
            </div>

            {importSelectedDevisId && importSelectedPosteIds.size > 0 && (
              <div className="p-4 border-t border-slate-200 bg-sky-50 flex items-center justify-between gap-3">
                <div className="text-sm text-slate-700">
                  <span className="font-semibold">{importSelectedPosteIds.size}</span> ligne{importSelectedPosteIds.size > 1 ? 's' : ''} sélectionnée{importSelectedPosteIds.size > 1 ? 's' : ''}
                </div>
                <button
                  onClick={confirmImportPostes}
                  className="px-4 py-2 bg-sky-600 hover:bg-sky-700 text-white rounded-lg text-sm font-semibold"
                  data-testid="confirm-import-postes-btn"
                >
                  Importer dans ce devis
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal - Nouveau Groupement (bundle of prestations) */}
      {showGroupementModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-testid="groupement-modal">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl mx-4 max-h-[92vh] flex flex-col">
            <div className="flex items-center justify-between p-5 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2">
                  <Package className="w-5 h-5 text-indigo-600" /> Nouveau groupement
                </h2>
                <p className="text-xs text-slate-500">Lot {groupementData.lot_id} – {groupementData.lot_nom}</p>
              </div>
              <button onClick={() => setShowGroupementModal(false)} className="text-slate-400 hover:text-slate-600" data-testid="groupement-close">
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto p-5 space-y-4">
              {/* Nom & description */}
              <div className="grid md:grid-cols-3 gap-4">
                <div className="md:col-span-1">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Nom du groupement *</label>
                  <input
                    type="text"
                    value={groupementData.nom}
                    onChange={(e) => setGroupementData({...groupementData, nom: e.target.value})}
                    placeholder="Ex: Caisse ADOPT, Arrière-caisse…"
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    data-testid="groupement-nom-input"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Description (optionnel)</label>
                  <input
                    type="text"
                    value={groupementData.description}
                    onChange={(e) => setGroupementData({...groupementData, description: e.target.value})}
                    placeholder="Ex: Installation complète zone caisse avec alimentations et connectique"
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
              </div>

              {/* Contexte hiérarchique */}
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Sous-lot *</label>
                  <select
                    value={groupementData.sous_lot_nom}
                    onChange={(e) => setGroupementData({...groupementData, sous_lot_nom: e.target.value})}
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    data-testid="groupement-sous-lot-select"
                  >
                    <option value="">— Choisir un sous-lot —</option>
                    {sousLotsTemplates.map(sl => (
                      <option key={sl.id} value={sl.nom}>{sl.nom}</option>
                    ))}
                  </select>
                  <p className="text-[10px] text-slate-500 mt-0.5">Modifiable dans Base MAAG → Sous-lots par défaut</p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Nom du groupement = sous-sous-lot</label>
                  <div className="h-10 px-3 flex items-center text-xs text-slate-500 italic bg-slate-50 border border-slate-200 rounded-lg">
                    Le nom ci-dessus sera utilisé comme 3ème niveau dans le devis
                  </div>
                </div>
              </div>

              {/* IA Correct */}
              <div className="flex items-center gap-2 p-3 bg-violet-50 border border-violet-200 rounded-lg">
                <Sparkles className="w-4 h-4 text-violet-700" />
                <span className="text-xs text-violet-900 flex-1">Saisissez vos lignes (désignations + descriptions brouillon), l'IA corrigera uniquement le texte sans toucher aux prix ni quantités.</span>
                <button
                  onClick={aiCorrectGroupementLignes}
                  disabled={groupementLoading}
                  className="px-3 py-1.5 bg-violet-600 text-white rounded-lg text-xs font-medium hover:bg-violet-700 disabled:opacity-50 flex items-center gap-1"
                  data-testid="groupement-ai-correct"
                >
                  {groupementLoading ? <Loader2 className="w-3 h-3 animate-spin" /> : <Sparkles className="w-3 h-3" />}
                  Corriger mes lignes
                </button>
              </div>

              {/* Lignes */}
              <div>
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium text-slate-700">Prestations ({groupementData.lignes.length})</label>
                  <button onClick={addGroupementLigne} className="text-xs text-indigo-600 hover:text-indigo-800 flex items-center gap-1" data-testid="groupement-add-ligne">
                    <Plus className="w-3 h-3" /> Ajouter une ligne
                  </button>
                </div>
                <div className="space-y-2">
                  {groupementData.lignes.map((ligne, idx) => (
                    <div key={idx} className="space-y-1">
                      <div className="grid grid-cols-12 gap-2 p-2 bg-slate-50 border border-slate-200 rounded items-center">
                        <button
                          onClick={() => { setGroupementPickerIdx(idx); setGroupementPickerSearch(''); }}
                          className="col-span-1 h-8 flex items-center justify-center bg-white border border-indigo-300 text-indigo-700 rounded text-xs hover:bg-indigo-50"
                          title="Choisir depuis Base MAAG"
                          data-testid={`groupement-base-maag-${idx}`}
                        >
                          <Database className="w-3.5 h-3.5" />
                        </button>
                        <input
                          type="text"
                          value={ligne.designation}
                          onChange={(e) => updateGroupementLigne(idx, 'designation', e.target.value.toUpperCase())}
                          placeholder="DÉSIGNATION"
                          className="col-span-3 h-8 px-2 text-xs border border-slate-300 rounded uppercase"
                          data-testid={`groupement-ligne-desig-${idx}`}
                        />
                        <input
                          type="text"
                          value={ligne.description}
                          onChange={(e) => updateGroupementLigne(idx, 'description', e.target.value)}
                          placeholder="Description courte"
                          className="col-span-4 h-8 px-2 text-xs border border-slate-300 rounded"
                        />
                        <select
                          value={ligne.unite}
                          onChange={(e) => updateGroupementLigne(idx, 'unite', e.target.value)}
                          className="col-span-1 h-8 px-1 text-xs border border-slate-300 rounded"
                        >
                          <option value="U">U</option>
                          <option value="ML">ML</option>
                          <option value="M²">M²</option>
                          <option value="M³">M³</option>
                          <option value="FORFAIT">FORF</option>
                          <option value="ENS">ENS</option>
                        </select>
                        <input
                          type="number"
                          step="0.01"
                          value={ligne.quantite}
                          onChange={(e) => updateGroupementLigne(idx, 'quantite', e.target.value)}
                          placeholder="Qté"
                          className="col-span-1 h-8 px-1 text-xs border border-slate-300 rounded text-right"
                        />
                        <input
                          type="number"
                          step="0.01"
                          value={ligne.prix_unitaire}
                          onChange={(e) => updateGroupementLigne(idx, 'prix_unitaire', e.target.value)}
                          placeholder="PU"
                          className="col-span-1 h-8 px-1 text-xs border border-slate-300 rounded text-right"
                        />
                        <button
                          onClick={() => removeGroupementLigne(idx)}
                          className="col-span-1 flex items-center justify-center text-slate-400 hover:text-red-600"
                          title="Supprimer cette ligne"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                      {groupementPickerIdx === idx && (
                        <div className="border border-indigo-300 rounded-lg bg-white p-2 shadow-lg" data-testid={`groupement-base-maag-picker-${idx}`}>
                          <div className="flex items-center gap-2 mb-2">
                            <Search className="w-3.5 h-3.5 text-slate-400" />
                            <input
                              type="text"
                              value={groupementPickerSearch}
                              onChange={(e) => setGroupementPickerSearch(e.target.value)}
                              placeholder="Rechercher dans Base MAAG (désignation, description)..."
                              autoFocus
                              className="flex-1 h-8 px-2 text-xs border border-slate-300 rounded"
                            />
                            <button onClick={() => setGroupementPickerIdx(null)} className="text-slate-400 hover:text-slate-600">
                              <X className="w-4 h-4" />
                            </button>
                          </div>
                          <div className="max-h-48 overflow-y-auto space-y-1">
                            {(() => {
                              const search = groupementPickerSearch.toLowerCase();
                              const filtered = (baseMaagPrestations || []).filter(p => {
                                // Filter by lot_id of the groupement
                                if (groupementData.lot_id && String(p.lot_id) !== String(groupementData.lot_id)) return false;
                                if (!search) return true;
                                const hay = `${p.designation || ''} ${p.description || ''} ${p.code || ''}`.toLowerCase();
                                return hay.includes(search);
                              }).slice(0, 30);
                              if (filtered.length === 0) return <div className="text-xs text-slate-400 italic p-2">Aucune prestation trouvée dans la Base MAAG pour ce lot.</div>;
                              return filtered.map(p => (
                                <button
                                  key={p.id}
                                  onClick={() => fillGroupementLigneFromBaseMaag(idx, p)}
                                  className="w-full text-left p-2 hover:bg-indigo-50 border border-slate-100 rounded text-xs flex items-center justify-between gap-2"
                                  data-testid={`groupement-pick-${p.id}`}
                                >
                                  <div className="flex-1 min-w-0">
                                    <div className="font-semibold text-slate-800 truncate">{p.designation || (p.description || '').slice(0, 60)}</div>
                                    {p.description && <div className="text-[10px] text-slate-500 truncate">{p.description.slice(0, 90)}</div>}
                                  </div>
                                  <div className="text-right flex-shrink-0">
                                    <div className="font-mono text-slate-700">{formatMoney(p.prix_enseigne || p.prix_base_maag || p.prix_unitaire || 0)}</div>
                                    <div className="text-[9px] text-slate-400">{p.unite} · {p.code || ''}</div>
                                  </div>
                                </button>
                              ));
                            })()}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Assignation */}
              <div className="bg-slate-50 border border-slate-200 rounded-lg p-3">
                <h3 className="text-sm font-semibold text-slate-700 mb-2">Enregistrer ce groupement ?</h3>
                <div className="space-y-2">
                  <label className="flex items-start gap-2 cursor-pointer p-2 border border-slate-200 rounded hover:bg-white">
                    <input
                      type="radio"
                      name="groupement-scope"
                      value="devis"
                      checked={groupementData.save_scope === 'devis'}
                      onChange={(e) => setGroupementData({...groupementData, save_scope: e.target.value})}
                      className="mt-0.5"
                      data-testid="groupement-scope-devis"
                    />
                    <div className="flex-1">
                      <div className="text-sm font-medium text-slate-800">🔒 Uniquement pour ce devis</div>
                      <div className="text-xs text-slate-500">Inséré tel quel dans le devis, non réutilisable</div>
                    </div>
                  </label>
                  <label className={`flex items-start gap-2 cursor-pointer p-2 border border-slate-200 rounded hover:bg-white ${!enseigneId ? 'opacity-50' : ''}`}>
                    <input
                      type="radio"
                      name="groupement-scope"
                      value="enseigne"
                      checked={groupementData.save_scope === 'enseigne'}
                      onChange={(e) => setGroupementData({...groupementData, save_scope: e.target.value})}
                      disabled={!enseigneId}
                      className="mt-0.5"
                      data-testid="groupement-scope-enseigne"
                    />
                    <div className="flex-1">
                      <div className="text-sm font-medium text-slate-800">🔷 Pour l'enseigne {(enseignes.find(e => e.id === enseigneId) || {}).nom || '(aucune)'}</div>
                      <div className="text-xs text-slate-500">Sauvegardé, réutilisable sur tous les futurs devis de cette enseigne</div>
                    </div>
                  </label>
                  <label className="flex items-start gap-2 cursor-pointer p-2 border border-slate-200 rounded hover:bg-white">
                    <input
                      type="radio"
                      name="groupement-scope"
                      value="maag"
                      checked={groupementData.save_scope === 'maag'}
                      onChange={(e) => setGroupementData({...groupementData, save_scope: e.target.value})}
                      className="mt-0.5"
                      data-testid="groupement-scope-maag"
                    />
                    <div className="flex-1">
                      <div className="text-sm font-medium text-slate-800">📗 Base MAAG globale</div>
                      <div className="text-xs text-slate-500">Réutilisable sur toutes les enseignes</div>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 p-4 border-t border-slate-200">
              <button
                onClick={() => setShowGroupementModal(false)}
                className="px-4 py-2 text-sm font-medium text-slate-600 border border-slate-300 rounded-lg hover:bg-slate-50"
              >
                Annuler
              </button>
              <button
                onClick={submitGroupement}
                disabled={groupementLoading}
                className="px-4 py-2 text-sm font-medium bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 flex items-center gap-2"
                data-testid="groupement-submit"
              >
                {groupementLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />}
                Créer le groupement
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal - New Poste with Enrichment */}
      {showNewPosteModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 max-h-[90vh] flex flex-col">
            <div className="flex items-center justify-between p-6 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">
                  {editingPosteId ? 'Modifier la prestation' : 'Nouvelle prestation'}
                </h2>
                <p className="text-sm text-slate-500">Lot {newPosteData.lot_id} - {newPosteData.lot_nom}</p>
                {editingPosteId && newPosteData.from_catalog_id !== 'existing' && (
                  <p className="text-xs text-indigo-600 mt-1">
                    💡 Non encore au catalogue. Vous pouvez choisir de l'y ajouter ci-dessous.
                  </p>
                )}
              </div>
              <button 
                onClick={() => {
                  setShowNewPosteModal(false);
                  setShowBaseMaagSelector(false);
                  setBaseMaagSearch('');
                  setEditingPosteId(null);
                }} 
                className="p-2 hover:bg-slate-100 rounded-lg"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-6 space-y-4 overflow-y-auto flex-1">
              {/* Base MAAG Selector Toggle */}
              <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-3">
                <button
                  onClick={() => setShowBaseMaagSelector(!showBaseMaagSelector)}
                  className="flex items-center gap-2 text-indigo-700 font-medium text-sm w-full"
                >
                  <Database className="w-4 h-4" />
                  {showBaseMaagSelector ? 'Masquer la Base MAAG' : 'Choisir depuis la Base MAAG'}
                  <ChevronDown className={`w-4 h-4 ml-auto transition-transform ${showBaseMaagSelector ? 'rotate-180' : ''}`} />
                </button>
                
                {showBaseMaagSelector && (
                  <div className="mt-3 space-y-2">
                    {newPosteData.sous_lot_nom && (
                      <div className="flex items-center gap-2 text-xs bg-indigo-50 border border-indigo-200 rounded-lg px-2 py-1 text-indigo-700">
                        <span>Filtré sur :</span>
                        <span className="font-semibold">{newPosteData.sous_lot_nom}</span>
                        <button
                          onClick={() => setNewPosteData(prev => ({...prev, sous_lot_nom: ''}))}
                          className="ml-auto text-indigo-500 hover:text-indigo-800"
                          title="Voir toutes les prestations du lot"
                          data-testid="clear-sous-lot-filter"
                        >
                          Tout afficher ✕
                        </button>
                      </div>
                    )}
                    <div className="relative">
                      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                      <input
                        type="text"
                        placeholder="Rechercher une prestation..."
                        value={baseMaagSearch}
                        onChange={(e) => setBaseMaagSearch(e.target.value)}
                        className="w-full h-9 pl-10 pr-3 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div className="max-h-48 overflow-y-auto border border-slate-200 rounded-lg bg-white">
                      {baseMaagPrestations
                        .filter(p => 
                          p.lot_id === newPosteData.lot_id &&
                          (!newPosteData.sous_lot_nom || (p.sous_lot_nom || '').toLowerCase() === newPosteData.sous_lot_nom.toLowerCase()) &&
                          (baseMaagSearch === '' || 
                           p.designation.toLowerCase().includes(baseMaagSearch.toLowerCase()) ||
                           (p.description && p.description.toLowerCase().includes(baseMaagSearch.toLowerCase())))
                        )
                        .map((p) => (
                          <button
                            key={p.id}
                            onClick={() => {
                              setNewPosteData({
                                ...newPosteData,
                                designation: p.designation,
                                description: p.description || '',
                                unite: p.unite || 'U',
                                quantite: p.quantite_defaut || newPosteData.quantite || 1,
                                prix_unitaire: p.prix_unitaire_base || 0,
                                // Auto-attach to its sous-lot if the catalog entry has one
                                sous_lot_nom: p.sous_lot_nom || newPosteData.sous_lot_nom || '',
                                // Mark as picked from catalog → force scope local, no duplicate
                                from_catalog_id: p.id,
                                scope: 'local',
                                // Snapshot original values to detect modifications
                                _catalog_original: {
                                  designation: p.designation,
                                  description: p.description || '',
                                  unite: p.unite || 'U',
                                  prix_maag: p.prix_unitaire_base || 0
                                },
                                updateCatalog: false
                              });
                              setShowBaseMaagSelector(false);
                              setBaseMaagSearch('');
                              toast.success(p.sous_lot_nom
                                ? `Prestation sélectionnée (sous-lot : ${p.sous_lot_nom})`
                                : 'Prestation sélectionnée');
                            }}
                            className="w-full px-3 py-2 text-left hover:bg-indigo-50 border-b border-slate-100 last:border-0"
                          >
                            <p className="text-sm font-medium text-slate-900">{p.designation}</p>
                            {p.description && (
                              <p className="text-xs text-slate-500 truncate">{p.description}</p>
                            )}
                            <p className="text-xs text-indigo-600 mt-1">
                              {p.unite} - {p.prix_unitaire_base || 0} € HT
                            </p>
                          </button>
                        ))
                      }
                      {baseMaagPrestations.filter(p => 
                        p.lot_id === newPosteData.lot_id &&
                        (baseMaagSearch === '' || 
                         p.designation.toLowerCase().includes(baseMaagSearch.toLowerCase()))
                      ).length === 0 && (
                        <p className="p-3 text-sm text-slate-500 text-center">
                          Aucune prestation trouvée pour ce lot
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Désignation *
                  {newPosteData.from_catalog_id && (
                    <span className="ml-2 text-xs font-normal text-indigo-600 bg-indigo-50 px-2 py-0.5 rounded">
                      📦 Issu de la Base MAAG
                    </span>
                  )}
                </label>
                <input
                  type="text"
                  value={newPosteData.designation}
                  onChange={(e) => setNewPosteData({...newPosteData, designation: e.target.value, from_catalog_id: null})}
                  placeholder="Ex: Fourniture et pose de..."
                  className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                />
                {newPosteData.from_catalog_id && (
                  <p className="text-xs text-slate-500 mt-1">
                    Article déjà dans le catalogue — aucune copie ne sera créée. Modifiez le texte pour créer un nouvel article.
                  </p>
                )}
                {/* Detect modifications: if user edited text, offer to propagate to catalog */}
                {newPosteData.from_catalog_id && newPosteData.from_catalog_id !== 'existing' && newPosteData._catalog_original && (() => {
                  const orig = newPosteData._catalog_original;
                  const modified =
                    (newPosteData.designation || '').trim() !== (orig.designation || '').trim() ||
                    (newPosteData.description || '').trim() !== (orig.description || '').trim() ||
                    (newPosteData.unite || '') !== (orig.unite || '') ||
                    (parseFloat(newPosteData.prix_unitaire) || 0) !== (orig.prix_maag || 0);
                  if (!modified) return null;
                  return (
                    <label className="mt-2 flex items-start gap-2 p-2 bg-emerald-50 border border-emerald-200 rounded-lg cursor-pointer">
                      <input
                        type="checkbox"
                        checked={!!newPosteData.updateCatalog}
                        onChange={(e) => setNewPosteData(prev => ({ ...prev, updateCatalog: e.target.checked }))}
                        className="mt-0.5 w-4 h-4 rounded border-emerald-300 text-emerald-600 focus:ring-emerald-500"
                        data-testid="update-catalog-checkbox"
                      />
                      <div className="text-xs">
                        <div className="font-medium text-emerald-800">
                          Enregistrer aussi cette modification dans la Base MAAG
                        </div>
                        <div className="text-emerald-700 mt-0.5">
                          L'article sera mis à jour dans le catalogue pour tous les futurs devis.
                        </div>
                      </div>
                    </label>
                  );
                })()}
              </div>
              
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Description détaillée</label>
                <textarea
                  value={newPosteData.description}
                  onChange={(e) => setNewPosteData({...newPosteData, description: e.target.value})}
                  placeholder="Description complète de la prestation..."
                  rows={5}
                  style={{ minHeight: '140px' }}
                  spellCheck="true"
                  lang="fr"
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-y"
                />
                {/* IA : génère TITRE + DESCRIPTION à partir du texte saisi */}
                <div className="mt-2">
                  <AIDescriptionButton
                    sourceText={`${newPosteData.designation || ''}\n${newPosteData.description || ''}`.trim()}
                    type="SPECIFIQUE"
                    lot={newPosteData.lot_nom || ''}
                    onResult={({ titre, description }) =>
                      setNewPosteData(prev => ({ ...prev, designation: titre, description }))
                    }
                  />
                </div>
              </div>
              
              {/* Localisation & Commentaire spécifiques au devis (apparaissent en bleu sur le PDF si remplis) */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-3 bg-blue-50/60 rounded-lg border border-blue-100">
                <div>
                  <label className="block text-xs font-medium text-blue-800 mb-1">
                    Localisation <span className="text-blue-400 font-normal">(optionnel)</span>
                  </label>
                  <LocalisationCombobox
                    value={newPosteData.localisation}
                    onChange={(v) => setNewPosteData({...newPosteData, localisation: v})}
                    options={localisationsList}
                    placeholder="Ex: WC, façade, entrée magasin..."
                    testId="poste-localisation-input"
                  />
                  <p className="text-[10px] text-blue-600 mt-0.5">Tapez ou choisissez dans la liste. Mémorisée pour les prochains devis.</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-blue-800 mb-1">
                    Commentaire <span className="text-blue-400 font-normal">(optionnel, spécifique à ce devis)</span>
                  </label>
                  <textarea
                    value={newPosteData.commentaire}
                    onChange={(e) => setNewPosteData({...newPosteData, commentaire: e.target.value})}
                    placeholder="Ex: coloris noir, pose selon plan…"
                    rows={2}
                    style={{ minHeight: '56px' }}
                    spellCheck="true"
                    lang="fr"
                    className="w-full px-2 py-1.5 text-sm border border-blue-200 rounded bg-white focus:outline-none focus:ring-2 focus:ring-blue-400 resize-y"
                    data-testid="poste-commentaire-input"
                  />
                  <p className="text-[10px] text-emerald-700 mt-0.5">Apparaît en vert sous la prestation sur le PDF.</p>
                </div>
              </div>
              
              {/* Sous-lot selector */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Sous-lot <span className="text-slate-400 font-normal">(choisir dans la liste ou taper un nouveau)</span>
                </label>
                <input
                  type="text"
                  value={newPosteData.sous_lot_nom || ''}
                  onChange={(e) => setNewPosteData({...newPosteData, sous_lot_nom: e.target.value.toUpperCase()})}
                  placeholder="Choisir ou taper un sous-lot…"
                  className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 uppercase"
                  list="sous-lots-suggestions-dyn"
                />
                <datalist id="sous-lots-suggestions-dyn">
                  {sousLotsTemplates.map(sl => (
                    <option key={sl.id} value={sl.nom} />
                  ))}
                </datalist>
                <p className="text-xs text-slate-500 mt-1">
                  {sousLotsTemplates.length > 0
                    ? `${sousLotsTemplates.length} sous-lots pré-définis (modifiables dans Base MAAG → Sous-lots par défaut)`
                    : 'Aucun template pour ce lot — tape librement.'}
                </p>
              </div>
              
              {/* Sous-sous-lot selector (3rd level) */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Sous-sous-lot <span className="text-slate-400 font-normal">(optionnel - niveau supplémentaire)</span>
                </label>
                <input
                  type="text"
                  value={newPosteData.sous_sous_lot_nom || ''}
                  onChange={(e) => setNewPosteData({...newPosteData, sous_sous_lot_nom: e.target.value.toUpperCase()})}
                  placeholder="Ex: TIRAGE DES ALIMENTATIONS, SIGNALETIQUE..."
                  className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 uppercase"
                  disabled={!newPosteData.sous_lot_nom && !newPosteData.sous_sous_lot_nom}
                  data-testid="poste-sous-sous-lot-input"
                />
                <p className="text-xs text-slate-500 mt-1">
                  {newPosteData.sous_lot_nom
                    ? "Ajoute un 3ème niveau sous le sous-lot. Laissez vide si non applicable."
                    : "Renseignez d'abord un sous-lot pour activer ce champ."}
                </p>
              </div>

              {/* Groupe (4ème niveau) — ex: Caisse, Enseigne, Bureau */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Groupe <span className="text-slate-400 font-normal">(optionnel - regroupe plusieurs prestations sous un titre)</span>
                </label>
                <input
                  type="text"
                  value={newPosteData.groupe_nom || ''}
                  onChange={(e) => setNewPosteData({...newPosteData, groupe_nom: e.target.value})}
                  placeholder="Ex: Caisse, Meuble COS, Bureau, Enseigne, Vidéo surveillance…"
                  className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  data-testid="poste-groupe-input"
                />
                <p className="text-xs text-slate-500 mt-1">
                  Sur le PDF : apparaît comme un titre <strong className="text-slate-700">gras bleu MAAG</strong> (sans prix) au-dessus des prestations de ce groupe.
                </p>
              </div>

              {/* Ligne titre libre — transforme cette entrée en simple titre décoratif */}
              <div className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                <input
                  id="is-titre-libre"
                  type="checkbox"
                  checked={!!newPosteData.is_titre_libre}
                  onChange={(e) => setNewPosteData({...newPosteData, is_titre_libre: e.target.checked})}
                  className="mt-0.5 w-4 h-4"
                  data-testid="poste-is-titre-libre"
                />
                <label htmlFor="is-titre-libre" className="text-sm text-amber-900 cursor-pointer">
                  <span className="font-semibold">Ligne titre libre</span> — pas de prix, pas de quantité. Juste un libellé en gras bleu MAAG sur le PDF pour aérer / structurer.
                </label>
              </div>
              
              <div className="grid grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Unité</label>
                  <select
                    value={newPosteData.unite}
                    onChange={(e) => setNewPosteData({...newPosteData, unite: e.target.value})}
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  >
                    <option value="U">U</option>
                    <option value="m²">m²</option>
                    <option value="ml">ml</option>
                    <option value="H">H</option>
                    <option value="FORFAIT">FORFAIT</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Quantité</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newPosteData.quantite}
                    onChange={(e) => setNewPosteData({...newPosteData, quantite: e.target.value})}
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-right"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Prix unitaire HT</label>
                  <input
                    type="number"
                    step="0.01"
                    value={newPosteData.prix_unitaire}
                    onChange={(e) => setNewPosteData({...newPosteData, prix_unitaire: e.target.value})}
                    className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-right"
                  />
                </div>
              </div>
              
              {/* Assignment scope selector — only when creating a NEW article (not picked from catalog) */}
              {!newPosteData.from_catalog_id && (
              <div className="bg-slate-50 rounded-lg p-4 space-y-3" data-testid="article-scope-section">
                <div className="flex items-center justify-between">
                  <p className="text-sm font-semibold text-slate-700">Assignation de l'article</p>
                  {previewCode && newPosteData.scope !== 'local' && (
                    <span className="text-[11px] font-mono bg-indigo-100 text-indigo-800 px-2 py-0.5 rounded" data-testid="preview-code">
                      Code auto : <b>{previewCode}</b>
                    </span>
                  )}
                </div>
                <p className="text-xs text-slate-500 -mt-2">
                  Choisissez où l'article sera enregistré. Sans sélection, il reste uniquement dans ce devis.
                </p>
                
                <div className="space-y-2">
                  <label className="flex items-start gap-3 cursor-pointer p-2 hover:bg-white rounded-lg transition-colors border border-transparent has-[:checked]:border-slate-300 has-[:checked]:bg-white">
                    <input
                      type="radio"
                      name="scope"
                      value="local"
                      checked={newPosteData.scope === 'local'}
                      onChange={() => setNewPosteData({...newPosteData, scope: 'local'})}
                      className="w-5 h-5 mt-0.5"
                      data-testid="scope-local-radio"
                    />
                    <div>
                      <div className="flex items-center gap-2">
                        <FileText className="w-4 h-4 text-slate-600" />
                        <span className="font-medium text-slate-900">Uniquement ce devis</span>
                      </div>
                      <p className="text-xs text-slate-500 mt-0.5">Article ponctuel, non ajouté au catalogue.</p>
                    </div>
                  </label>
                  
                  <label className="flex items-start gap-3 cursor-pointer p-2 hover:bg-white rounded-lg transition-colors border border-transparent has-[:checked]:border-indigo-300 has-[:checked]:bg-white">
                    <input
                      type="radio"
                      name="scope"
                      value="maag"
                      checked={newPosteData.scope === 'maag'}
                      onChange={() => setNewPosteData({...newPosteData, scope: 'maag'})}
                      className="w-5 h-5 mt-0.5"
                      data-testid="scope-maag-radio"
                    />
                    <div>
                      <div className="flex items-center gap-2">
                        <Database className="w-4 h-4 text-indigo-600" />
                        <span className="font-medium text-slate-900">Article MAAG (global)</span>
                      </div>
                      <p className="text-xs text-slate-500 mt-0.5">Disponible pour toutes les enseignes.</p>
                    </div>
                  </label>
                  
                  <label className="flex items-start gap-3 cursor-pointer p-2 hover:bg-white rounded-lg transition-colors border border-transparent has-[:checked]:border-orange-300 has-[:checked]:bg-white">
                    <input
                      type="radio"
                      name="scope"
                      value="enseigne"
                      checked={newPosteData.scope === 'enseigne'}
                      onChange={() => setNewPosteData({...newPosteData, scope: 'enseigne'})}
                      className="w-5 h-5 mt-0.5"
                      data-testid="scope-enseigne-radio"
                    />
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <Building2 className="w-4 h-4 text-orange-600" />
                        <span className="font-medium text-slate-900">Spécifique à une enseigne</span>
                      </div>
                      <p className="text-xs text-slate-500 mt-0.5 mb-2">Prix enregistré pour cette enseigne uniquement.</p>
                      {newPosteData.scope === 'enseigne' && (
                        <select
                          value={newPosteData.scope_enseigne_id}
                          onChange={(e) => setNewPosteData({...newPosteData, scope_enseigne_id: e.target.value})}
                          className="w-full h-9 px-2 text-sm border border-slate-300 rounded focus:ring-2 focus:ring-orange-500 focus:outline-none bg-white"
                          data-testid="scope-enseigne-select"
                        >
                          <option value="">— Choisir une enseigne —</option>
                          {enseignes.map(ens => (
                            <option key={ens.id} value={ens.id}>{ens.nom}</option>
                          ))}
                        </select>
                      )}
                    </div>
                  </label>
                </div>
                
                {/* Add to devis type checkbox - only relevant when saving to catalog */}
                {newPosteData.scope !== 'local' && (
                  <label className="flex items-start gap-3 cursor-pointer p-2 hover:bg-white rounded-lg transition-colors border-t border-slate-200 pt-3">
                    <input
                      type="checkbox"
                      checked={newPosteData.addToDevisType}
                      onChange={(e) => setNewPosteData({...newPosteData, addToDevisType: e.target.checked})}
                      className="w-5 h-5 mt-0.5 rounded border-slate-300 text-green-600 focus:ring-green-500"
                      data-testid="add-to-devis-type-checkbox"
                    />
                    <div>
                      <div className="flex items-center gap-2">
                        <Building2 className="w-4 h-4 text-green-600" />
                        <span className="font-medium text-slate-900">Ajouter au devis type</span>
                      </div>
                      <p className="text-xs text-slate-500 mt-0.5">Inclure automatiquement dans les futurs devis.</p>
                    </div>
                  </label>
                )}

                {/* Prix Base MAAG + Prix Enseigne - only when saving to catalog */}
                {newPosteData.scope !== 'local' && (
                  <div className="grid grid-cols-2 gap-3 mt-3 p-3 bg-white rounded-lg border border-slate-200">
                    <div>
                      <label className="block text-xs font-medium text-slate-600 mb-1">Prix Base MAAG (HT)</label>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={newPosteData.prix_base_maag}
                        onChange={(e) => setNewPosteData({...newPosteData, prix_base_maag: e.target.value})}
                        placeholder={String(newPosteData.prix_unitaire || 0)}
                        className="w-full h-9 px-2 text-sm border border-slate-300 rounded focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                        data-testid="prix-base-maag-input"
                      />
                      <p className="text-[10px] text-slate-400 mt-0.5">Prix par défaut toutes enseignes</p>
                    </div>
                    {newPosteData.scope === 'enseigne' && (
                      <div>
                        <label className="block text-xs font-medium text-slate-600 mb-1">
                          Prix Enseigne (HT)
                        </label>
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          value={newPosteData.prix_enseigne}
                          onChange={(e) => setNewPosteData({...newPosteData, prix_enseigne: e.target.value})}
                          placeholder={String(newPosteData.prix_unitaire || 0)}
                          className="w-full h-9 px-2 text-sm border border-slate-300 rounded focus:ring-2 focus:ring-orange-500 focus:outline-none"
                          data-testid="prix-enseigne-input"
                        />
                        <p className="text-[10px] text-slate-400 mt-0.5">Prix spécifique à l'enseigne</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              )}
            </div>
            
            <div className="p-6 border-t border-slate-200 bg-slate-50 rounded-b-xl flex gap-3">
              <button
                type="button"
                onClick={() => setShowNewPosteModal(false)}
                className="flex-1 h-10 border border-slate-300 text-slate-700 rounded-lg font-medium hover:bg-white transition-colors"
              >
                Annuler
              </button>
              <button
                type="button"
                onClick={handleCreatePosteWithEnrichment}
                disabled={creatingPoste || !newPosteData.designation}
                className="flex-1 h-10 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {creatingPoste ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    {editingPosteId ? 'Mise à jour...' : 'Création...'}
                  </>
                ) : (
                  <>
                    <Plus className="w-4 h-4" />
                    {editingPosteId ? 'Mettre à jour' : 'Créer'}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal - Titre du devis */}
      {showTitreModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4">
            <div className="flex items-center justify-between p-6 border-b border-slate-200">
              <div>
                <h2 className="text-lg font-bold text-slate-900">Titre du devis</h2>
                <p className="text-sm text-slate-500">Ce titre apparaîtra sur le PDF du devis</p>
              </div>
              <button 
                onClick={() => setShowTitreModal(false)}
                className="p-2 hover:bg-slate-100 rounded-lg"
              >
                ✕
              </button>
            </div>
            
            <div className="p-6 space-y-4">
              <p className="text-sm font-medium text-slate-700">Choisir un titre prédéfini :</p>
              <div className="space-y-2">
                {titresDevis.map(titre => (
                  <button
                    key={titre.code}
                    onClick={async () => {
                      await handleSaveDevis('titre_devis', titre.code);
                      await handleSaveDevis('titre_devis_custom', '');
                      setShowTitreModal(false);
                      toast.success('Titre mis à jour');
                    }}
                    className={`w-full p-3 text-left border-2 rounded-lg transition-all ${
                      devis.titre_devis === titre.code && !devis.titre_devis_custom
                        ? 'border-indigo-500 bg-indigo-50'
                        : 'border-slate-200 hover:border-slate-300'
                    }`}
                  >
                    <p className="font-semibold text-slate-900">{titre.titre}</p>
                    <p className="text-xs text-slate-500">{titre.sous_titre}</p>
                  </button>
                ))}
              </div>

              <div className="pt-4 border-t border-slate-200">
                <p className="text-sm font-medium text-slate-700 mb-2">Ou saisir un titre personnalisé :</p>
                <input
                  type="text"
                  placeholder="Ex: DEVIS AGENCEMENT BOUTIQUE"
                  defaultValue={devis.titre_devis_custom || ''}
                  className="w-full h-10 px-4 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  onBlur={async (e) => {
                    if (e.target.value.trim()) {
                      await handleSaveDevis('titre_devis_custom', e.target.value.trim().toUpperCase());
                      setShowTitreModal(false);
                      toast.success('Titre personnalisé enregistré');
                    }
                  }}
                  onKeyDown={async (e) => {
                    if (e.key === 'Enter' && e.target.value.trim()) {
                      await handleSaveDevis('titre_devis_custom', e.target.value.trim().toUpperCase());
                      setShowTitreModal(false);
                      toast.success('Titre personnalisé enregistré');
                    }
                  }}
                />
                <p className="text-xs text-slate-400 mt-1">Appuyez sur Entrée pour valider</p>
              </div>
            </div>

            <div className="p-6 border-t border-slate-200 bg-slate-50 rounded-b-xl">
              <button
                type="button"
                onClick={() => setShowTitreModal(false)}
                className="w-full h-10 border border-slate-300 text-slate-700 rounded-lg font-medium hover:bg-white"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal - Edit Sous-lot */}
      {editingSousLot && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4">
            <div className="flex items-center justify-between p-4 border-b border-slate-200">
              <h2 className="text-lg font-bold text-slate-900">Modifier le sous-lot</h2>
              <button 
                onClick={() => { setEditingSousLot(null); setNewSousLotName(''); }}
                className="p-2 hover:bg-slate-100 rounded-lg"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-4 space-y-4">
              {/* Existing sous-lots */}
              {getExistingSousLots(editingSousLot.lotId).length > 0 && (
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">Sous-lots existants (cliquez pour sélectionner)</label>
                  <div className="flex flex-wrap gap-2">
                    {getExistingSousLots(editingSousLot.lotId).map(sl => (
                      <button
                        key={sl}
                        onClick={() => setNewSousLotName(sl)}
                        className={`px-3 py-1.5 text-sm rounded-lg border transition-colors ${
                          newSousLotName === sl 
                            ? 'bg-indigo-100 border-indigo-500 text-indigo-700' 
                            : 'bg-slate-50 border-slate-200 text-slate-700 hover:border-slate-300'
                        }`}
                      >
                        {sl}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Sous-lot name */}
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Nom du sous-lot
                </label>
                <input
                  type="text"
                  value={newSousLotName}
                  onChange={(e) => setNewSousLotName(e.target.value.toUpperCase())}
                  placeholder="Ex: 1. COURANTS FORTS, 2. VDI, 3. ECLAIRAGE..."
                  className="w-full h-10 px-3 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  autoFocus
                />
                <p className="text-xs text-slate-500 mt-1">Mettez un numéro au début pour hiérarchiser (ex: "1. COURANTS FORTS"). Laissez vide pour retirer du sous-lot.</p>
              </div>
            </div>
            
            <div className="flex gap-3 p-4 border-t border-slate-200 bg-slate-50 rounded-b-xl">
              <button
                onClick={() => { setEditingSousLot(null); setNewSousLotName(''); }}
                className="flex-1 h-10 border border-slate-300 text-slate-700 rounded-lg font-medium hover:bg-white"
              >
                Annuler
              </button>
              <button
                onClick={() => handleUpdateSousLot(editingSousLot.posteId, newSousLotName.trim())}
                className="flex-1 h-10 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700"
              >
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* AI rewrite modal for existing postes */}
      <AIRewritePosteModal
        open={!!aiRewriteTarget}
        onClose={() => setAiRewriteTarget(null)}
        currentText={aiRewriteTarget?.text || ''}
        lot={aiRewriteTarget?.lotNom || ''}
        onAccept={async (newText) => {
          try {
            await updatePoste(aiRewriteTarget.posteId, { description: newText });
            toast.success('Prestation réécrite');
            loadData();
          } catch (e) {
            toast.error("Erreur lors de la mise à jour");
          }
        }}
      />

      {pdfNameDialog && (
        <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4" data-testid="pdf-name-dialog" onClick={() => setPdfNameDialog(null)}>
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-xl p-5" onClick={(e) => e.stopPropagation()}>
            <h3 className="text-lg font-semibold text-slate-900 flex items-center gap-2"><FileText className="w-5 h-5 text-indigo-600" /> Nom du fichier PDF</h3>
            <p className="text-xs text-slate-500 mt-1">Vérifiez le nom avant de générer le PDF. Format : <b>Date - Enseigne - Ville - Objet</b>. Modifiable si besoin.</p>
            <input
              value={pdfNameDialog.fname}
              onChange={(e) => setPdfNameDialog({ fname: e.target.value })}
              onKeyDown={(e) => { if (e.key === 'Enter') confirmExportPdf(); if (e.key === 'Escape') setPdfNameDialog(null); }}
              autoFocus
              className="mt-3 w-full h-11 px-3 rounded-lg border border-slate-300 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-indigo-500"
              data-testid="pdf-name-input"
            />
            {/(\b\w{3,}\b)[\s\S]*\b\1\b/i.test(pdfNameDialog.fname.replace(/\.pdf$/i, '').replace(/^\d{4}-\d{2}-\d{2} - /, '')) && (
              <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1 mt-2" data-testid="pdf-name-doublon">Un mot semble répété dans le nom — vérifiez qu'il n'y a pas de doublon (ex. enseigne ou ville écrite deux fois).</p>
            )}
            <div className="flex justify-end gap-2 mt-4">
              <button type="button" onClick={() => setPdfNameDialog(null)} className="h-10 px-4 border border-slate-300 rounded-lg text-sm hover:bg-slate-50">Annuler</button>
              <button type="button" onClick={() => setPdfNameDialog({ fname: buildPdfFilename() })} className="h-10 px-4 border border-slate-300 rounded-lg text-sm hover:bg-slate-50" data-testid="pdf-name-reset-btn">Nom proposé</button>
              <button type="button" onClick={confirmExportPdf} className="h-10 px-5 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700" data-testid="pdf-name-confirm-btn">Générer le PDF</button>
            </div>
          </div>
        </div>
      )}

      {pdfPreview && (
        <PDFPreviewModal
          url={pdfPreview.url}
          title={pdfPreview.title}
          downloadFilename={pdfPreview.filename}
          onClose={closePdfPreview}
        />
      )}
    </div>
  );
};

export default DevisEditPage;
